// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Common = require("../utils/Common.bs.js");
var Js_math = require("rescript/lib/js/js_math.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var MM_parser = require("../mm-utils/MM_parser.bs.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("../mm-utils/MM_context.bs.js");
var MM_provers = require("../mm-utils/MM_provers.bs.js");
var Belt_MapInt = require("rescript/lib/js/belt_MapInt.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_SetInt = require("rescript/lib/js/belt_SetInt.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Belt_HashMap = require("rescript/lib/js/belt_HashMap.js");
var Belt_HashSet = require("rescript/lib/js/belt_HashSet.js");
var MM_proof_tree = require("../mm-utils/MM_proof_tree.bs.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var MM_proof_table = require("../mm-utils/MM_proof_table.bs.js");
var MM_syntax_tree = require("../mm-utils/MM_syntax_tree.bs.js");
var Belt_HashMapInt = require("rescript/lib/js/belt_HashMapInt.js");
var Belt_HashSetInt = require("rescript/lib/js/belt_HashSetInt.js");
var MM_parenCounter = require("../mm-utils/MM_parenCounter.bs.js");
var MM_substitution = require("../mm-utils/MM_substitution.bs.js");
var MM_wrk_ctx_data = require("./MM_wrk_ctx_data.bs.js");
var Expln_utils_data = require("@expln/utils/src/main/Expln_utils_data.bs.js");
var MM_proof_tree_dto = require("../mm-utils/MM_proof_tree_dto.bs.js");
var MM_proof_verifier = require("../mm-utils/MM_proof_verifier.bs.js");
var MM_statements_dto = require("../mm-utils/MM_statements_dto.bs.js");
var Belt_HashMapString = require("rescript/lib/js/belt_HashMapString.js");
var Belt_HashSetString = require("rescript/lib/js/belt_HashSetString.js");
var Belt_MutableMapInt = require("rescript/lib/js/belt_MutableMapInt.js");
var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");
var Expln_utils_common = require("@expln/utils/src/main/Expln_utils_common.bs.js");
var MM_unification_debug = require("../mm-utils/MM_unification_debug.bs.js");
var Belt_MutableMapString = require("rescript/lib/js/belt_MutableMapString.js");

var newLabelPrefix = "";

function contIsEmpty(cont) {
  if (cont.TAG === /* Text */0) {
    return cont._0.length === 0;
  } else {
    return MM_syntax_tree.syntaxTreeIsEmpty(cont._0.root);
  }
}

function contToArrStr(cont) {
  if (cont.TAG === /* Text */0) {
    return cont._0.map(function (stmtSym) {
                return stmtSym.sym;
              });
  }
  var match = cont._0;
  return [match.exprTyp].concat(MM_syntax_tree.syntaxTreeToSymbols(match.root));
}

function contToStr(cont) {
  return contToArrStr(cont).join(" ");
}

function strToCont(str, preCtxColors, wrkCtxColors, param) {
  return {
          TAG: /* Text */0,
          _0: Common.getSpaceSeparatedValuesAsArray(str).map(function (sym) {
                var color = Belt_Option.flatMap(preCtxColors, (function (map) {
                        return Belt_HashMapString.get(map, sym);
                      }));
                var tmp;
                if (color !== undefined) {
                  tmp = color;
                } else {
                  var color$1 = Belt_Option.flatMap(wrkCtxColors, (function (map) {
                          return Belt_HashMapString.get(map, sym);
                        }));
                  tmp = color$1 !== undefined ? color$1 : undefined;
                }
                return {
                        sym: sym,
                        color: tmp
                      };
              })
        };
}

function userStmtTypeFromStr(str) {
  switch (str) {
    case "e" :
        return /* E */0;
    case "p" :
        return /* P */1;
    default:
      throw {
            RE_EXN_ID: MM_parser.MmException,
            _1: {
              msg: "Cannot convert '" + str + "' to userStmtType"
            },
            Error: new Error()
          };
  }
}

function userStmtTypeToStr(typ) {
  if (typ) {
    return "p";
  } else {
    return "e";
  }
}

function readInstrToStr(ri) {
  switch (ri) {
    case /* ReadAll */0 :
        return "ReadAll";
    case /* StopBefore */1 :
        return "StopBefore";
    case /* StopAfter */2 :
        return "StopAfter";
    
  }
}

function readInstrFromStr(str) {
  switch (str) {
    case "ReadAll" :
        return /* ReadAll */0;
    case "StopAfter" :
        return /* StopAfter */2;
    case "StopBefore" :
        return /* StopBefore */1;
    default:
      throw {
            RE_EXN_ID: MM_parser.MmException,
            _1: {
              msg: "Cannot convert string '" + str + "' to a readInstr."
            },
            Error: new Error()
          };
  }
}

function mmFileSourceTypeToStr(src) {
  if (src) {
    return "Web";
  } else {
    return "Local";
  }
}

function mmFileSourceTypeFromStr(str) {
  switch (str) {
    case "Local" :
        return /* Local */0;
    case "Web" :
        return /* Web */1;
    default:
      throw {
            RE_EXN_ID: MM_parser.MmException,
            _1: {
              msg: "Cannot convert string '" + str + "' to an mmFileSourceType."
            },
            Error: new Error()
          };
  }
}

function mmFileSourceTypeFromStrOpt(str) {
  switch (str) {
    case "Local" :
        return /* Local */0;
    case "Web" :
        return /* Web */1;
    default:
      return ;
  }
}

function createEmptyUserStmt(id, typ, label) {
  return {
          id: id,
          label: label,
          labelEditMode: false,
          typ: typ,
          typEditMode: false,
          cont: {
            TAG: /* Text */0,
            _0: []
          },
          contEditMode: true,
          jstfText: "",
          jstfEditMode: false,
          stmtErr: undefined,
          expr: undefined,
          jstf: undefined,
          proofTreeDto: undefined,
          src: undefined,
          proof: undefined,
          proofStatus: undefined,
          unifErr: undefined,
          syntaxErr: undefined
        };
}

function userStmtToRootStmt(stmt) {
  var expr = stmt.expr;
  var tmp;
  if (expr !== undefined) {
    tmp = expr;
  } else {
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "Expr must be set for a userStmt before converting to rootStmt."
          },
          Error: new Error()
        };
  }
  return {
          isHyp: stmt.typ === /* E */0,
          label: stmt.label,
          expr: tmp,
          jstf: stmt.jstf
        };
}

function unselectStmt(stmt) {
  var treeData = stmt.cont;
  if (treeData.TAG === /* Text */0) {
    return stmt;
  }
  var treeData$1 = treeData._0;
  var match = treeData$1.clickedNodeId;
  if (match !== undefined) {
    return {
            id: stmt.id,
            label: stmt.label,
            labelEditMode: stmt.labelEditMode,
            typ: stmt.typ,
            typEditMode: stmt.typEditMode,
            cont: {
              TAG: /* Tree */1,
              _0: {
                exprTyp: treeData$1.exprTyp,
                root: treeData$1.root,
                clickedNodeId: undefined,
                expLvl: treeData$1.expLvl
              }
            },
            contEditMode: stmt.contEditMode,
            jstfText: stmt.jstfText,
            jstfEditMode: stmt.jstfEditMode,
            stmtErr: stmt.stmtErr,
            expr: stmt.expr,
            jstf: stmt.jstf,
            proofTreeDto: stmt.proofTreeDto,
            src: stmt.src,
            proof: stmt.proof,
            proofStatus: stmt.proofStatus,
            unifErr: stmt.unifErr,
            syntaxErr: stmt.syntaxErr
          };
  } else {
    return stmt;
  }
}

function editorGetStmtById(st, id) {
  return Caml_option.undefined_to_opt(st.stmts.find(function (stmt) {
                  return stmt.id === id;
                }));
}

function editorGetStmtByIdExn(st, id) {
  var stmt = editorGetStmtById(st, id);
  if (stmt !== undefined) {
    return stmt;
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "editorGetStmtByIdExn: Cannot find a statement by statement id."
        },
        Error: new Error()
      };
}

function getStmtIdx(st, id) {
  return st.stmts.findIndex(function (stmt) {
              return stmt.id === id;
            });
}

function updateStmt(st, id, update) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.stmts = st.stmts.map(function (stmt) {
        if (stmt.id === id) {
          return Curry._1(update, stmt);
        } else {
          return stmt;
        }
      });
  return newrecord;
}

function isStmtChecked(st, id) {
  return st.checkedStmtIds.includes(id);
}

function toggleStmtChecked(st, id) {
  if (st.checkedStmtIds.includes(id)) {
    var newrecord = Caml_obj.obj_dup(st);
    newrecord.checkedStmtIds = st.checkedStmtIds.filter(function (checkedId) {
          return checkedId !== id;
        });
    return newrecord;
  }
  var newrecord$1 = Caml_obj.obj_dup(st);
  newrecord$1.checkedStmtIds = st.checkedStmtIds.concat([id]);
  return newrecord$1;
}

function checkAllStmts(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.checkedStmtIds = st.stmts.map(function (stmt) {
        return stmt.id;
      });
  return newrecord;
}

function uncheckAllStmts(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.checkedStmtIds = [];
  newrecord.stmts = st.stmts.map(unselectStmt);
  return newrecord;
}

function deleteCheckedStmts(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.checkedStmtIds = [];
  newrecord.stmts = st.stmts.filter(function (stmt) {
        return !st.checkedStmtIds.includes(stmt.id);
      });
  return newrecord;
}

function deleteStmt(st, id) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.checkedStmtIds = st.checkedStmtIds.filter(function (checkedId) {
        return checkedId !== id;
      });
  newrecord.stmts = st.stmts.filter(function (stmt) {
        return stmt.id !== id;
      });
  return newrecord;
}

function canMoveCheckedStmts(st, up) {
  var len = st.stmts.length;
  if (len !== 0 && st.checkedStmtIds.length !== 0) {
    if (up && !st.checkedStmtIds.includes(Caml_array.get(st.stmts, 0).id)) {
      return true;
    } else if (up) {
      return false;
    } else {
      return !st.checkedStmtIds.includes(Caml_array.get(st.stmts, len - 1 | 0).id);
    }
  } else {
    return false;
  }
}

function moveCheckedStmts(st, up) {
  if (!canMoveCheckedStmts(st, up)) {
    return st;
  }
  var len = st.stmts.length;
  var res = st.stmts.slice();
  if (up) {
    var maxI = len - 2 | 0;
    for(var i = 0; i <= maxI; ++i){
      if (!st.checkedStmtIds.includes(Caml_array.get(res, i).id) && st.checkedStmtIds.includes(Caml_array.get(res, i + 1 | 0).id)) {
        var tmp = Caml_array.get(res, i);
        Caml_array.set(res, i, Caml_array.get(res, i + 1 | 0));
        Caml_array.set(res, i + 1 | 0, tmp);
      }
      
    }
  } else {
    for(var i$1 = len - 1 | 0; i$1 >= 1; --i$1){
      if (st.checkedStmtIds.includes(Caml_array.get(res, i$1 - 1 | 0).id) && !st.checkedStmtIds.includes(Caml_array.get(res, i$1).id)) {
        var tmp$1 = Caml_array.get(res, i$1);
        Caml_array.set(res, i$1, Caml_array.get(res, i$1 - 1 | 0));
        Caml_array.set(res, i$1 - 1 | 0, tmp$1);
      }
      
    }
  }
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.stmts = res;
  return newrecord;
}

function getRootStmtsForUnification(st) {
  var checkedAdded = false;
  var res = [];
  var i = 0;
  var stmtsLen = st.stmts.length;
  while(i < stmtsLen && !checkedAdded) {
    var stmt = Caml_array.get(st.stmts, i);
    res.push(stmt);
    checkedAdded = st.checkedStmtIds.includes(stmt.id);
    i = i + 1 | 0;
  };
  return res;
}

function createNewLabel(st, prefix) {
  var reservedLabels = Belt_HashSetString.fromArray(st.stmts.map(function (stmt) {
            return stmt.label;
          }));
  var varDefs = MM_wrk_ctx_data.textToVarDefs(st.varsText);
  if (varDefs.TAG === /* Ok */0) {
    varDefs._0.forEach(function (varDef) {
          Belt_HashSetString.add(reservedLabels, Caml_array.get(varDef, 0));
        });
  }
  var labelIsReserved = function (label) {
    if (Belt_HashSetString.has(reservedLabels, label)) {
      return true;
    } else {
      return MM_context.isHyp(st.preCtx, label);
    }
  };
  var cnt = 1;
  var newLabel = prefix + String(cnt);
  while(labelIsReserved(newLabel)) {
    cnt = cnt + 1 | 0;
    newLabel = prefix + String(cnt);
  };
  return newLabel;
}

function getTopmostCheckedStmt(st) {
  if (st.checkedStmtIds.length === 0) {
    return ;
  } else {
    return Caml_option.undefined_to_opt(st.stmts.find(function (stmt) {
                    return st.checkedStmtIds.includes(stmt.id);
                  }));
  }
}

function addNewStmt(st) {
  var newId = String(st.nextStmtId);
  var newLabel = createNewLabel(st, newLabelPrefix);
  var idToAddBefore = Belt_Option.map(getTopmostCheckedStmt(st), (function (stmt) {
          return stmt.id;
        }));
  var newrecord = Caml_obj.obj_dup(st);
  return [
          (newrecord.stmts = idToAddBefore !== undefined ? Belt_Array.concatMany(st.stmts.map(function (stmt) {
                        if (stmt.id === idToAddBefore) {
                          return [
                                  createEmptyUserStmt(newId, /* P */1, newLabel),
                                  stmt
                                ];
                        } else {
                          return [stmt];
                        }
                      })) : st.stmts.concat([createEmptyUserStmt(newId, /* P */1, newLabel)]), newrecord.nextStmtId = st.nextStmtId + 1 | 0, newrecord),
          newId
        ];
}

function addNewStmtAtIdx(st, idx) {
  var savedCheckedStmtIds = st.checkedStmtIds;
  var st$1 = uncheckAllStmts(st);
  var st$2 = 0 <= idx && idx < st$1.stmts.length ? toggleStmtChecked(st$1, Caml_array.get(st$1.stmts, idx).id) : st$1;
  var match = addNewStmt(st$2);
  var newrecord = Caml_obj.obj_dup(match[0]);
  newrecord.checkedStmtIds = savedCheckedStmtIds;
  return [
          newrecord,
          match[1]
        ];
}

function isSingleStmtChecked(st) {
  return st.checkedStmtIds.length === 1;
}

function duplicateCheckedStmt(st) {
  if (!isSingleStmtChecked(st)) {
    return st;
  }
  var newId = String(st.nextStmtId);
  var newLabel = createNewLabel(st, newLabelPrefix);
  var idToAddAfter = Caml_array.get(st.checkedStmtIds, 0);
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.checkedStmtIds = [newId];
  newrecord.stmts = Belt_Array.concatMany(st.stmts.map(function (stmt) {
            if (stmt.id === idToAddAfter) {
              return [
                      stmt,
                      {
                        id: newId,
                        label: newLabel,
                        labelEditMode: stmt.labelEditMode,
                        typ: stmt.typ,
                        typEditMode: stmt.typEditMode,
                        cont: stmt.cont,
                        contEditMode: stmt.contEditMode,
                        jstfText: "",
                        jstfEditMode: stmt.jstfEditMode,
                        stmtErr: stmt.stmtErr,
                        expr: stmt.expr,
                        jstf: stmt.jstf,
                        proofTreeDto: stmt.proofTreeDto,
                        src: stmt.src,
                        proof: stmt.proof,
                        proofStatus: stmt.proofStatus,
                        unifErr: stmt.unifErr,
                        syntaxErr: stmt.syntaxErr
                      }
                    ];
            } else {
              return [stmt];
            }
          }));
  newrecord.nextStmtId = st.nextStmtId + 1 | 0;
  return newrecord;
}

function canGoEditModeForStmt(st, stmtId) {
  return !st.stmts.some(function (stmt) {
              if (stmt.id === stmtId) {
                if (stmt.labelEditMode || stmt.typEditMode || stmt.contEditMode) {
                  return true;
                } else {
                  return stmt.jstfEditMode;
                }
              } else {
                return false;
              }
            });
}

function setDescrEditMode(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.descrEditMode = true;
  return newrecord;
}

function setVarsEditMode(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.varsEditMode = true;
  return newrecord;
}

function setDisjEditMode(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.disjEditMode = true;
  return newrecord;
}

function completeDisjEditMode(st, newDisjText) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.disjEditMode = false;
  newrecord.disjText = newDisjText;
  return newrecord;
}

function setLabelEditMode(st, stmtId) {
  if (canGoEditModeForStmt(st, stmtId)) {
    return updateStmt(st, stmtId, (function (stmt) {
                  return {
                          id: stmt.id,
                          label: stmt.label,
                          labelEditMode: true,
                          typ: stmt.typ,
                          typEditMode: stmt.typEditMode,
                          cont: stmt.cont,
                          contEditMode: stmt.contEditMode,
                          jstfText: stmt.jstfText,
                          jstfEditMode: stmt.jstfEditMode,
                          stmtErr: stmt.stmtErr,
                          expr: stmt.expr,
                          jstf: stmt.jstf,
                          proofTreeDto: stmt.proofTreeDto,
                          src: stmt.src,
                          proof: stmt.proof,
                          proofStatus: stmt.proofStatus,
                          unifErr: stmt.unifErr,
                          syntaxErr: stmt.syntaxErr
                        };
                }));
  } else {
    return st;
  }
}

function completeLabelEditMode(st, stmtId, newLabel) {
  return updateStmt(st, stmtId, (function (stmt) {
                if (newLabel.trim() !== "") {
                  return {
                          id: stmt.id,
                          label: newLabel,
                          labelEditMode: false,
                          typ: stmt.typ,
                          typEditMode: stmt.typEditMode,
                          cont: stmt.cont,
                          contEditMode: stmt.contEditMode,
                          jstfText: stmt.jstfText,
                          jstfEditMode: stmt.jstfEditMode,
                          stmtErr: stmt.stmtErr,
                          expr: stmt.expr,
                          jstf: stmt.jstf,
                          proofTreeDto: stmt.proofTreeDto,
                          src: stmt.src,
                          proof: stmt.proof,
                          proofStatus: stmt.proofStatus,
                          unifErr: stmt.unifErr,
                          syntaxErr: stmt.syntaxErr
                        };
                } else {
                  return stmt;
                }
              }));
}

function setContEditMode(st, stmtId) {
  if (canGoEditModeForStmt(st, stmtId)) {
    return updateStmt(st, stmtId, (function (stmt) {
                  return {
                          id: stmt.id,
                          label: stmt.label,
                          labelEditMode: stmt.labelEditMode,
                          typ: stmt.typ,
                          typEditMode: stmt.typEditMode,
                          cont: stmt.cont,
                          contEditMode: true,
                          jstfText: stmt.jstfText,
                          jstfEditMode: stmt.jstfEditMode,
                          stmtErr: stmt.stmtErr,
                          expr: stmt.expr,
                          jstf: stmt.jstf,
                          proofTreeDto: stmt.proofTreeDto,
                          src: stmt.src,
                          proof: stmt.proof,
                          proofStatus: stmt.proofStatus,
                          unifErr: stmt.unifErr,
                          syntaxErr: stmt.syntaxErr
                        };
                }));
  } else {
    return st;
  }
}

function completeContEditMode(st, stmtId, newContText) {
  return updateStmt(st, stmtId, (function (stmt) {
                if (newContText.trim() === "") {
                  return stmt;
                } else {
                  return {
                          id: stmt.id,
                          label: stmt.label,
                          labelEditMode: stmt.labelEditMode,
                          typ: stmt.typ,
                          typEditMode: stmt.typEditMode,
                          cont: strToCont(newContText, Caml_option.some(st.preCtxColors), Caml_option.some(st.wrkCtxColors), undefined),
                          contEditMode: false,
                          jstfText: stmt.jstfText,
                          jstfEditMode: stmt.jstfEditMode,
                          stmtErr: stmt.stmtErr,
                          expr: stmt.expr,
                          jstf: stmt.jstf,
                          proofTreeDto: stmt.proofTreeDto,
                          src: stmt.src,
                          proof: stmt.proof,
                          proofStatus: stmt.proofStatus,
                          unifErr: stmt.unifErr,
                          syntaxErr: stmt.syntaxErr
                        };
                }
              }));
}

function setStmtCont(st, stmtId, stmtCont) {
  return updateStmt(st, stmtId, (function (stmt) {
                return {
                        id: stmt.id,
                        label: stmt.label,
                        labelEditMode: stmt.labelEditMode,
                        typ: stmt.typ,
                        typEditMode: stmt.typEditMode,
                        cont: stmtCont,
                        contEditMode: stmt.contEditMode,
                        jstfText: stmt.jstfText,
                        jstfEditMode: stmt.jstfEditMode,
                        stmtErr: stmt.stmtErr,
                        expr: stmt.expr,
                        jstf: stmt.jstf,
                        proofTreeDto: stmt.proofTreeDto,
                        src: stmt.src,
                        proof: stmt.proof,
                        proofStatus: stmt.proofStatus,
                        unifErr: stmt.unifErr,
                        syntaxErr: stmt.syntaxErr
                      };
              }));
}

function setTypEditMode(st, stmtId) {
  if (canGoEditModeForStmt(st, stmtId)) {
    return updateStmt(st, stmtId, (function (stmt) {
                  return {
                          id: stmt.id,
                          label: stmt.label,
                          labelEditMode: stmt.labelEditMode,
                          typ: stmt.typ,
                          typEditMode: true,
                          cont: stmt.cont,
                          contEditMode: stmt.contEditMode,
                          jstfText: stmt.jstfText,
                          jstfEditMode: stmt.jstfEditMode,
                          stmtErr: stmt.stmtErr,
                          expr: stmt.expr,
                          jstf: stmt.jstf,
                          proofTreeDto: stmt.proofTreeDto,
                          src: stmt.src,
                          proof: stmt.proof,
                          proofStatus: stmt.proofStatus,
                          unifErr: stmt.unifErr,
                          syntaxErr: stmt.syntaxErr
                        };
                }));
  } else {
    return st;
  }
}

function completeTypEditMode(st, stmtId, newTyp) {
  return updateStmt(st, stmtId, (function (stmt) {
                return {
                        id: stmt.id,
                        label: stmt.label,
                        labelEditMode: stmt.labelEditMode,
                        typ: newTyp,
                        typEditMode: false,
                        cont: stmt.cont,
                        contEditMode: stmt.contEditMode,
                        jstfText: stmt.jstfText,
                        jstfEditMode: stmt.jstfEditMode,
                        stmtErr: stmt.stmtErr,
                        expr: stmt.expr,
                        jstf: stmt.jstf,
                        proofTreeDto: stmt.proofTreeDto,
                        src: stmt.src,
                        proof: stmt.proof,
                        proofStatus: stmt.proofStatus,
                        unifErr: stmt.unifErr,
                        syntaxErr: stmt.syntaxErr
                      };
              }));
}

function setJstfEditMode(st, stmtId) {
  if (canGoEditModeForStmt(st, stmtId)) {
    return updateStmt(st, stmtId, (function (stmt) {
                  return {
                          id: stmt.id,
                          label: stmt.label,
                          labelEditMode: stmt.labelEditMode,
                          typ: stmt.typ,
                          typEditMode: stmt.typEditMode,
                          cont: stmt.cont,
                          contEditMode: stmt.contEditMode,
                          jstfText: stmt.jstfText,
                          jstfEditMode: true,
                          stmtErr: stmt.stmtErr,
                          expr: stmt.expr,
                          jstf: stmt.jstf,
                          proofTreeDto: stmt.proofTreeDto,
                          src: stmt.src,
                          proof: stmt.proof,
                          proofStatus: stmt.proofStatus,
                          unifErr: stmt.unifErr,
                          syntaxErr: stmt.syntaxErr
                        };
                }));
  } else {
    return st;
  }
}

function completeJstfEditMode(st, stmtId, newJstf) {
  return updateStmt(st, stmtId, (function (stmt) {
                return {
                        id: stmt.id,
                        label: stmt.label,
                        labelEditMode: stmt.labelEditMode,
                        typ: stmt.typ,
                        typEditMode: stmt.typEditMode,
                        cont: stmt.cont,
                        contEditMode: stmt.contEditMode,
                        jstfText: newJstf,
                        jstfEditMode: false,
                        stmtErr: stmt.stmtErr,
                        expr: stmt.expr,
                        jstf: stmt.jstf,
                        proofTreeDto: stmt.proofTreeDto,
                        src: stmt.src,
                        proof: stmt.proof,
                        proofStatus: stmt.proofStatus,
                        unifErr: stmt.unifErr,
                        syntaxErr: stmt.syntaxErr
                      };
              }));
}

function incUnifyAllIsRequiredCnt(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.unifyAllIsRequiredCnt = st.unifyAllIsRequiredCnt + 1 | 0;
  return newrecord;
}

function extractVarColorsFromVarsText(varsText, typeColors) {
  var res = Belt_HashMapString.make(16);
  var varDefs = MM_wrk_ctx_data.textToVarDefs(varsText);
  if (varDefs.TAG === /* Ok */0) {
    varDefs._0.forEach(function (varDef) {
          var varName = Caml_array.get(varDef, 2);
          var typ = Caml_array.get(varDef, 1);
          var color = Belt_HashMapString.get(typeColors, typ);
          if (color !== undefined) {
            return Belt_HashMapString.set(res, varName, color);
          }
          
        });
  }
  return res;
}

function recalcTypeColors(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.typeColors = Belt_HashMapString.fromArray(st.settings.typeSettings.map(function (ts) {
            return [
                    ts.typ,
                    ts.color
                  ];
          }));
  return newrecord;
}

function recalcPreCtxColors(st) {
  var preCtxColors = Belt_HashMapString.make(100);
  MM_context.forEachHypothesisInDeclarationOrder(st.preCtx, (function (hyp) {
          if (hyp.typ === /* F */0) {
            var typeStr = MM_context.ctxIntToSym(st.preCtx, Caml_array.get(hyp.expr, 0));
            if (typeStr !== undefined) {
              var color = Belt_HashMapString.get(st.typeColors, typeStr);
              if (color !== undefined) {
                Belt_HashMapString.set(preCtxColors, MM_context.ctxIntToSymExn(st.preCtx, Caml_array.get(hyp.expr, 1)), color);
              }
              
            }
            
          }
          
        }));
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.preCtxColors = preCtxColors;
  return newrecord;
}

function recalcWrkCtxColors(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.wrkCtxColors = extractVarColorsFromVarsText(st.varsText, st.typeColors);
  return newrecord;
}

function updateColorsInAllStmts(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.stmts = st.stmts.map(function (stmt) {
        return {
                id: stmt.id,
                label: stmt.label,
                labelEditMode: stmt.labelEditMode,
                typ: stmt.typ,
                typEditMode: stmt.typEditMode,
                cont: strToCont(contToArrStr(stmt.cont).join(" "), Caml_option.some(st.preCtxColors), Caml_option.some(st.wrkCtxColors), undefined),
                contEditMode: stmt.contEditMode,
                jstfText: stmt.jstfText,
                jstfEditMode: stmt.jstfEditMode,
                stmtErr: stmt.stmtErr,
                expr: stmt.expr,
                jstf: stmt.jstf,
                proofTreeDto: stmt.proofTreeDto,
                src: stmt.src,
                proof: stmt.proof,
                proofStatus: stmt.proofStatus,
                unifErr: stmt.unifErr,
                syntaxErr: stmt.syntaxErr
              };
      });
  return newrecord;
}

function findSyntaxTypes(frms) {
  var syntaxTypes = Belt_HashSetInt.make(16);
  Belt_MapString.forEach(frms, (function (param, frm) {
          frm.frame.hyps.forEach(function (hyp) {
                if (hyp.typ === /* F */0) {
                  return Belt_HashSetInt.add(syntaxTypes, Caml_array.get(hyp.expr, 0));
                }
                
              });
        }));
  return Belt_HashSetInt.toArray(syntaxTypes);
}

function setPreCtx(st, srcs, preCtxV, preCtx) {
  var preCtx$1 = MM_context.ctxOptimizeForProver(preCtx);
  MM_context.moveConstsToBegin(preCtx$1, st.settings.parens);
  var frms = MM_substitution.prepareFrmSubsData(preCtx$1, Caml_option.some(Belt_HashSetString.fromArray(st.settings.asrtsToSkip)), undefined);
  var parenInts = MM_wrk_ctx_data.prepareParenInts(preCtx$1, st.settings.parens);
  var numOfParens = parenInts.length / 2 | 0;
  var parensMap = Belt_HashMapString.make(numOfParens);
  for(var i = 0; i < numOfParens; ++i){
    Belt_HashMapString.set(parensMap, MM_context.ctxIntToSymExn(preCtx$1, Caml_array.get(parenInts, (i << 1))), MM_context.ctxIntToSymExn(preCtx$1, Caml_array.get(parenInts, (i << 1) + 1 | 0)));
  }
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.parensMap = parensMap;
  newrecord.syntaxTypes = findSyntaxTypes(frms);
  newrecord.parenCnt = MM_parenCounter.parenCntMake(parenInts, undefined, undefined);
  newrecord.frms = frms;
  newrecord.preCtx = preCtx$1;
  newrecord.preCtxV = preCtxV;
  newrecord.srcs = srcs;
  var st$1 = recalcPreCtxColors(newrecord);
  return updateColorsInAllStmts(recalcWrkCtxColors(st$1));
}

function setSettings(st, settingsV, settings) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.settings = settings;
  newrecord.settingsV = settingsV;
  var st$1 = setPreCtx(newrecord, newrecord.srcs, newrecord.preCtxV, newrecord.preCtx);
  var st$2 = recalcTypeColors(st$1);
  var st$3 = recalcPreCtxColors(st$2);
  return updateColorsInAllStmts(recalcWrkCtxColors(st$3));
}

function completeDescrEditMode(st, newDescr) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.descrEditMode = false;
  newrecord.descr = newDescr;
  return newrecord;
}

function completeVarsEditMode(st, newVarsText) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.varsEditMode = false;
  newrecord.varsText = newVarsText;
  return updateColorsInAllStmts(recalcWrkCtxColors(newrecord));
}

function sortStmtsByType(st) {
  var stmtToInt = function (stmt) {
    var match = stmt.typ;
    if (match) {
      return 2;
    } else {
      return 1;
    }
  };
  var comp = function (a, b) {
    return stmtToInt(a) - stmtToInt(b) | 0;
  };
  var stmtsLen = st.stmts.length;
  if (stmtsLen < 2) {
    return st;
  }
  var newStmts = st.stmts.slice();
  var changed = true;
  var e = stmtsLen - 2 | 0;
  while(e >= 0 && changed) {
    changed = false;
    for(var i = 0; i <= e; ++i){
      if (Curry._2(comp, Caml_array.get(newStmts, i), Caml_array.get(newStmts, i + 1 | 0)) > 0) {
        var tmp = Caml_array.get(newStmts, i);
        Caml_array.set(newStmts, i, Caml_array.get(newStmts, i + 1 | 0));
        Caml_array.set(newStmts, i + 1 | 0, tmp);
        changed = true;
      }
      
    }
    e = e - 1 | 0;
  };
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.stmts = newStmts;
  return newrecord;
}

function removeAllTempData(st) {
  var newrecord = Caml_obj.obj_dup(st);
  newrecord.stmts = st.stmts.map(function (stmt) {
        return {
                id: stmt.id,
                label: stmt.label,
                labelEditMode: stmt.labelEditMode,
                typ: stmt.typ,
                typEditMode: stmt.typEditMode,
                cont: stmt.cont,
                contEditMode: stmt.contEditMode,
                jstfText: stmt.jstfText,
                jstfEditMode: stmt.jstfEditMode,
                stmtErr: undefined,
                expr: undefined,
                jstf: undefined,
                proofTreeDto: undefined,
                src: undefined,
                proof: undefined,
                proofStatus: undefined,
                unifErr: undefined,
                syntaxErr: undefined
              };
      });
  newrecord.disjErr = undefined;
  newrecord.varsErr = undefined;
  return newrecord;
}

function userStmtHasErrors(stmt) {
  return Belt_Option.isSome(stmt.stmtErr);
}

function editorStateHasErrors(st) {
  if (Belt_Option.isSome(st.varsErr) || Belt_Option.isSome(st.disjErr)) {
    return true;
  } else {
    return st.stmts.some(userStmtHasErrors);
  }
}

function refreshWrkCtx(st) {
  var wrkCtxRes = MM_wrk_ctx_data.createWrkCtx(st.preCtx, st.varsText, st.disjText);
  if (wrkCtxRes.TAG !== /* Ok */0) {
    var wrkCtxErr = wrkCtxRes._0;
    var msg = wrkCtxErr.varsErr;
    var st$1;
    if (msg !== undefined) {
      var newrecord = Caml_obj.obj_dup(st);
      newrecord.varsErr = msg;
      st$1 = newrecord;
    } else {
      st$1 = st;
    }
    var msg$1 = wrkCtxErr.disjErr;
    if (msg$1 === undefined) {
      return st$1;
    }
    var newrecord$1 = Caml_obj.obj_dup(st$1);
    newrecord$1.disjErr = msg$1;
    return newrecord$1;
  }
  var newrecord$2 = Caml_obj.obj_dup(st);
  newrecord$2.wrkCtx = Caml_option.some(wrkCtxRes._0);
  return newrecord$2;
}

function parseJstf(jstfText) {
  var jstfText$1 = jstfText.trim();
  if (jstfText$1.length === 0) {
    return {
            TAG: /* Ok */0,
            _0: undefined
          };
  }
  var argsAndAsrt = jstfText$1.split(":");
  if (argsAndAsrt.length !== 2) {
    return {
            TAG: /* Error */1,
            _0: "Cannot parse justification: '" + jstfText$1 + "' [1]."
          };
  } else {
    return {
            TAG: /* Ok */0,
            _0: {
              args: Common.getSpaceSeparatedValuesAsArray(Caml_array.get(argsAndAsrt, 0)),
              label: Caml_array.get(argsAndAsrt, 1).trim()
            }
          };
  }
}

function setStmtJstf(stmt) {
  if (Belt_Option.isSome(stmt.stmtErr) || stmt.typ === /* E */0) {
    return stmt;
  }
  var msg = parseJstf(stmt.jstfText);
  if (msg.TAG === /* Ok */0) {
    return {
            id: stmt.id,
            label: stmt.label,
            labelEditMode: stmt.labelEditMode,
            typ: stmt.typ,
            typEditMode: stmt.typEditMode,
            cont: stmt.cont,
            contEditMode: stmt.contEditMode,
            jstfText: stmt.jstfText,
            jstfEditMode: stmt.jstfEditMode,
            stmtErr: stmt.stmtErr,
            expr: stmt.expr,
            jstf: msg._0,
            proofTreeDto: stmt.proofTreeDto,
            src: stmt.src,
            proof: stmt.proof,
            proofStatus: stmt.proofStatus,
            unifErr: stmt.unifErr,
            syntaxErr: stmt.syntaxErr
          };
  } else {
    return {
            id: stmt.id,
            label: stmt.label,
            labelEditMode: stmt.labelEditMode,
            typ: stmt.typ,
            typEditMode: stmt.typEditMode,
            cont: stmt.cont,
            contEditMode: stmt.contEditMode,
            jstfText: stmt.jstfText,
            jstfEditMode: stmt.jstfEditMode,
            stmtErr: msg._0,
            expr: stmt.expr,
            jstf: stmt.jstf,
            proofTreeDto: stmt.proofTreeDto,
            src: stmt.src,
            proof: stmt.proof,
            proofStatus: stmt.proofStatus,
            unifErr: stmt.unifErr,
            syntaxErr: stmt.syntaxErr
          };
  }
}

function isLabelDefined(label, wrkCtx, definedUserLabels) {
  if (Belt_HashSetString.has(definedUserLabels, label)) {
    return true;
  } else {
    return MM_context.isHyp(wrkCtx, label);
  }
}

function prepareUserStmtsForUnification(st) {
  var wrkCtx = st.wrkCtx;
  if (wrkCtx !== undefined) {
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var stmtsLen = st.stmts.length;
    var definedUserLabels = Belt_HashSetString.make(stmtsLen);
    var definedUserExprs = Belt_HashMap.make(stmtsLen, MM_context.ExprHash);
    var actions = [
      (function (__x) {
          if (Belt_Option.isSome(__x.stmtErr)) {
            return __x;
          }
          if (__x.typ !== /* E */0) {
            if (isLabelDefined(__x.label, wrkCtx$1, definedUserLabels)) {
              return {
                      id: __x.id,
                      label: __x.label,
                      labelEditMode: __x.labelEditMode,
                      typ: __x.typ,
                      typEditMode: __x.typEditMode,
                      cont: __x.cont,
                      contEditMode: __x.contEditMode,
                      jstfText: __x.jstfText,
                      jstfEditMode: __x.jstfEditMode,
                      stmtErr: "Cannot reuse label '" + __x.label + "' [3].",
                      expr: __x.expr,
                      jstf: __x.jstf,
                      proofTreeDto: __x.proofTreeDto,
                      src: __x.src,
                      proof: __x.proof,
                      proofStatus: __x.proofStatus,
                      unifErr: __x.unifErr,
                      syntaxErr: __x.syntaxErr
                    };
            } else {
              return __x;
            }
          }
          var match = MM_context.getTokenType(wrkCtx$1, __x.label);
          if (match !== undefined) {
            return {
                    id: __x.id,
                    label: __x.label,
                    labelEditMode: __x.labelEditMode,
                    typ: __x.typ,
                    typEditMode: __x.typEditMode,
                    cont: __x.cont,
                    contEditMode: __x.contEditMode,
                    jstfText: __x.jstfText,
                    jstfEditMode: __x.jstfEditMode,
                    stmtErr: "Cannot reuse label '" + __x.label + "' [1].",
                    expr: __x.expr,
                    jstf: __x.jstf,
                    proofTreeDto: __x.proofTreeDto,
                    src: __x.src,
                    proof: __x.proof,
                    proofStatus: __x.proofStatus,
                    unifErr: __x.unifErr,
                    syntaxErr: __x.syntaxErr
                  };
          } else if (isLabelDefined(__x.label, wrkCtx$1, definedUserLabels)) {
            return {
                    id: __x.id,
                    label: __x.label,
                    labelEditMode: __x.labelEditMode,
                    typ: __x.typ,
                    typEditMode: __x.typEditMode,
                    cont: __x.cont,
                    contEditMode: __x.contEditMode,
                    jstfText: __x.jstfText,
                    jstfEditMode: __x.jstfEditMode,
                    stmtErr: "Cannot reuse label '" + __x.label + "' [2].",
                    expr: __x.expr,
                    jstf: __x.jstf,
                    proofTreeDto: __x.proofTreeDto,
                    src: __x.src,
                    proof: __x.proof,
                    proofStatus: __x.proofStatus,
                    unifErr: __x.unifErr,
                    syntaxErr: __x.syntaxErr
                  };
          } else {
            return __x;
          }
        }),
      (function (__x) {
          if (Belt_Option.isSome(__x.stmtErr)) {
            return __x;
          }
          try {
            return {
                    id: __x.id,
                    label: __x.label,
                    labelEditMode: __x.labelEditMode,
                    typ: __x.typ,
                    typEditMode: __x.typEditMode,
                    cont: __x.cont,
                    contEditMode: __x.contEditMode,
                    jstfText: __x.jstfText,
                    jstfEditMode: __x.jstfEditMode,
                    stmtErr: __x.stmtErr,
                    expr: MM_context.ctxSymsToIntsExn(wrkCtx$1, contToArrStr(__x.cont)),
                    jstf: __x.jstf,
                    proofTreeDto: __x.proofTreeDto,
                    src: __x.src,
                    proof: __x.proof,
                    proofStatus: __x.proofStatus,
                    unifErr: __x.unifErr,
                    syntaxErr: __x.syntaxErr
                  };
          }
          catch (raw_exn){
            var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
            if (exn.RE_EXN_ID === MM_parser.MmException) {
              return {
                      id: __x.id,
                      label: __x.label,
                      labelEditMode: __x.labelEditMode,
                      typ: __x.typ,
                      typEditMode: __x.typEditMode,
                      cont: __x.cont,
                      contEditMode: __x.contEditMode,
                      jstfText: __x.jstfText,
                      jstfEditMode: __x.jstfEditMode,
                      stmtErr: exn._1.msg,
                      expr: __x.expr,
                      jstf: __x.jstf,
                      proofTreeDto: __x.proofTreeDto,
                      src: __x.src,
                      proof: __x.proof,
                      proofStatus: __x.proofStatus,
                      unifErr: __x.unifErr,
                      syntaxErr: __x.syntaxErr
                    };
            }
            throw exn;
          }
        }),
      (function (__x) {
          if (Belt_Option.isSome(__x.stmtErr)) {
            return __x;
          }
          var expr = __x.expr;
          if (expr !== undefined) {
            var hyp = MM_context.getHypByExpr(wrkCtx$1, expr);
            if (hyp !== undefined) {
              return {
                      id: __x.id,
                      label: __x.label,
                      labelEditMode: __x.labelEditMode,
                      typ: __x.typ,
                      typEditMode: __x.typEditMode,
                      cont: __x.cont,
                      contEditMode: __x.contEditMode,
                      jstfText: __x.jstfText,
                      jstfEditMode: __x.jstfEditMode,
                      stmtErr: "This statement is the same as the previously defined" + (" hypothesis - '" + hyp.label + "'"),
                      expr: __x.expr,
                      jstf: __x.jstf,
                      proofTreeDto: __x.proofTreeDto,
                      src: __x.src,
                      proof: __x.proof,
                      proofStatus: __x.proofStatus,
                      unifErr: __x.unifErr,
                      syntaxErr: __x.syntaxErr
                    };
            }
            var prevStmtLabel = Belt_HashMap.get(definedUserExprs, expr);
            if (prevStmtLabel !== undefined) {
              return {
                      id: __x.id,
                      label: __x.label,
                      labelEditMode: __x.labelEditMode,
                      typ: __x.typ,
                      typEditMode: __x.typEditMode,
                      cont: __x.cont,
                      contEditMode: __x.contEditMode,
                      jstfText: __x.jstfText,
                      jstfEditMode: __x.jstfEditMode,
                      stmtErr: "This statement is the same as the previous" + (" one - '" + prevStmtLabel + "'"),
                      expr: __x.expr,
                      jstf: __x.jstf,
                      proofTreeDto: __x.proofTreeDto,
                      src: __x.src,
                      proof: __x.proof,
                      proofStatus: __x.proofStatus,
                      unifErr: __x.unifErr,
                      syntaxErr: __x.syntaxErr
                    };
            } else {
              return __x;
            }
          }
          throw {
                RE_EXN_ID: MM_parser.MmException,
                _1: {
                  msg: "Cannot validateStmtExpr without expr."
                },
                Error: new Error()
              };
        }),
      setStmtJstf,
      (function (__x) {
          var asrtsToSkip = st.settings.asrtsToSkip;
          var frms = st.frms;
          if (Belt_Option.isSome(__x.stmtErr)) {
            return __x;
          }
          var match = __x.jstf;
          if (match === undefined) {
            return __x;
          }
          var label = match.label;
          var args = match.args;
          var jstfArgLabel = args.find(function (ref) {
                return !isLabelDefined(ref, wrkCtx$1, definedUserLabels);
              });
          if (jstfArgLabel !== undefined) {
            return {
                    id: __x.id,
                    label: __x.label,
                    labelEditMode: __x.labelEditMode,
                    typ: __x.typ,
                    typEditMode: __x.typEditMode,
                    cont: __x.cont,
                    contEditMode: __x.contEditMode,
                    jstfText: __x.jstfText,
                    jstfEditMode: __x.jstfEditMode,
                    stmtErr: "The label '" + jstfArgLabel + "' is not defined.",
                    expr: __x.expr,
                    jstf: __x.jstf,
                    proofTreeDto: __x.proofTreeDto,
                    src: __x.src,
                    proof: __x.proof,
                    proofStatus: __x.proofStatus,
                    unifErr: __x.unifErr,
                    syntaxErr: __x.syntaxErr
                  };
          }
          if (!MM_context.isAsrt(wrkCtx$1, label)) {
            return {
                    id: __x.id,
                    label: __x.label,
                    labelEditMode: __x.labelEditMode,
                    typ: __x.typ,
                    typEditMode: __x.typEditMode,
                    cont: __x.cont,
                    contEditMode: __x.contEditMode,
                    jstfText: __x.jstfText,
                    jstfEditMode: __x.jstfEditMode,
                    stmtErr: "The label '" + label + "' doesn't refer to any assertion.",
                    expr: __x.expr,
                    jstf: __x.jstf,
                    proofTreeDto: __x.proofTreeDto,
                    src: __x.src,
                    proof: __x.proof,
                    proofStatus: __x.proofStatus,
                    unifErr: __x.unifErr,
                    syntaxErr: __x.syntaxErr
                  };
          }
          if (asrtsToSkip.includes(label)) {
            return {
                    id: __x.id,
                    label: __x.label,
                    labelEditMode: __x.labelEditMode,
                    typ: __x.typ,
                    typEditMode: __x.typEditMode,
                    cont: __x.cont,
                    contEditMode: __x.contEditMode,
                    jstfText: __x.jstfText,
                    jstfEditMode: __x.jstfEditMode,
                    stmtErr: "The assertion '" + label + "' is skipped by settings.",
                    expr: __x.expr,
                    jstf: __x.jstf,
                    proofTreeDto: __x.proofTreeDto,
                    src: __x.src,
                    proof: __x.proof,
                    proofStatus: __x.proofStatus,
                    unifErr: __x.unifErr,
                    syntaxErr: __x.syntaxErr
                  };
          }
          var frm = Belt_MapString.get(frms, label);
          if (frm !== undefined) {
            var expectedNumberOfArgs = frm.numOfHypsE;
            var providedNumberOfArgs = args.length;
            if (providedNumberOfArgs === expectedNumberOfArgs) {
              return __x;
            }
            var eHypsText = expectedNumberOfArgs === 1 ? "essential hypothesis" : "essential hypotheses";
            var isAreText = providedNumberOfArgs === 1 ? "is" : "are";
            return {
                    id: __x.id,
                    label: __x.label,
                    labelEditMode: __x.labelEditMode,
                    typ: __x.typ,
                    typEditMode: __x.typEditMode,
                    cont: __x.cont,
                    contEditMode: __x.contEditMode,
                    jstfText: __x.jstfText,
                    jstfEditMode: __x.jstfEditMode,
                    stmtErr: "'" + label + "' assertion expects " + String(expectedNumberOfArgs) + " " + eHypsText + " but" + (" " + String(providedNumberOfArgs) + " " + isAreText + " provided."),
                    expr: __x.expr,
                    jstf: __x.jstf,
                    proofTreeDto: __x.proofTreeDto,
                    src: __x.src,
                    proof: __x.proof,
                    proofStatus: __x.proofStatus,
                    unifErr: __x.unifErr,
                    syntaxErr: __x.syntaxErr
                  };
          }
          throw {
                RE_EXN_ID: MM_parser.MmException,
                _1: {
                  msg: "Could not get frame by label '" + label + "'"
                },
                Error: new Error()
              };
        })
    ];
    return st.stmts.reduce((function (st, stmt) {
                  if (editorStateHasErrors(st)) {
                    return st;
                  }
                  var stmt$1 = actions.reduce((function (stmt, action) {
                          if (Belt_Option.isSome(stmt.stmtErr)) {
                            return stmt;
                          } else {
                            return Curry._1(action, stmt);
                          }
                        }), stmt);
                  Belt_HashSetString.add(definedUserLabels, stmt$1.label);
                  if (!Belt_Option.isSome(stmt$1.stmtErr)) {
                    var expr = stmt$1.expr;
                    if (expr !== undefined) {
                      Belt_HashMap.set(definedUserExprs, expr, stmt$1.label);
                    } else {
                      throw {
                            RE_EXN_ID: MM_parser.MmException,
                            _1: {
                              msg: "Expr must be set in prepareUserStmtsForUnification."
                            },
                            Error: new Error()
                          };
                    }
                  }
                  return updateStmt(st, stmt$1.id, (function (param) {
                                return stmt$1;
                              }));
                }), st);
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot prepareUserStmtsForUnification without wrkCtx."
        },
        Error: new Error()
      };
}

function prepareEditorForUnification(st) {
  var st$1 = removeAllTempData(st);
  return [
            sortStmtsByType,
            refreshWrkCtx,
            prepareUserStmtsForUnification
          ].reduce((function (st, act) {
                if (editorStateHasErrors(st)) {
                  return st;
                } else {
                  return Curry._1(act, st);
                }
              }), st$1);
}

function getTheOnlyCheckedStmt(st) {
  if (st.checkedStmtIds.length !== 1) {
    return ;
  } else {
    return getTopmostCheckedStmt(st);
  }
}

function createNewVars(st, varTypes) {
  var wrkCtx = st.wrkCtx;
  if (wrkCtx !== undefined) {
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var numOfVars = varTypes.length;
    if (numOfVars === 0) {
      return [
              st,
              []
            ];
    }
    var typeToPrefix = Belt_MapString.fromArray(st.settings.typeSettings.map(function (ts) {
              return [
                      ts.typ,
                      ts.prefix
                    ];
            }));
    var newVarNames = MM_context.generateNewVarNames(wrkCtx$1, varTypes, typeToPrefix, undefined, undefined);
    var newHypLabels = MM_context.generateNewLabels(wrkCtx$1, "var", numOfVars, undefined, undefined, undefined);
    MM_context.applySingleStmt(wrkCtx$1, {
          TAG: /* Var */3,
          symbols: newVarNames
        });
    var varTypeNames = MM_context.ctxIntsToSymsExn(wrkCtx$1, varTypes);
    newHypLabels.forEach(function (label, i) {
          MM_context.applySingleStmt(wrkCtx$1, {
                TAG: /* Floating */5,
                label: label,
                expr: [
                  Caml_array.get(varTypeNames, i),
                  Caml_array.get(newVarNames, i)
                ]
              });
        });
    var newVarInts = MM_context.ctxSymsToIntsExn(wrkCtx$1, newVarNames);
    var newVarsText = newHypLabels.map(function (label, i) {
            return "" + label + " " + Caml_array.get(varTypeNames, i) + " " + Caml_array.get(newVarNames, i) + "";
          }).join("\n");
    var newrecord = Caml_obj.obj_dup(st);
    newrecord.varsText = [
          st.varsText,
          newVarsText
        ].join("\n").trim();
    var st$1 = recalcWrkCtxColors(newrecord);
    return [
            st$1,
            newVarInts
          ];
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot create new variables without wrkCtx."
        },
        Error: new Error()
      };
}

function createNewDisj(st, newDisj) {
  var wrkCtx = st.wrkCtx;
  if (wrkCtx !== undefined) {
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var newDisjTextLines = [];
    MM_context.disjForEachArr(newDisj, (function (varInts) {
            var varsStr = MM_context.ctxIntsToSymsExn(wrkCtx$1, varInts);
            MM_context.applySingleStmt(wrkCtx$1, {
                  TAG: /* Disj */4,
                  vars: varsStr
                });
            newDisjTextLines.push(varsStr.join(","));
          }));
    if (newDisjTextLines.length === 0) {
      return st;
    }
    var newDisjText = newDisjTextLines.join("\n");
    var newrecord = Caml_obj.obj_dup(st);
    newrecord.disjText = [
          st.disjText,
          newDisjText
        ].join("\n").trim();
    return newrecord;
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot create new disjoints without wrkCtx."
        },
        Error: new Error()
      };
}

function stmtsHaveSameExpr(stmt, stmtDto) {
  var expr = stmt.expr;
  if (expr !== undefined) {
    return MM_context.exprEq(expr, stmtDto.expr);
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot compare statements without expr."
        },
        Error: new Error()
      };
}

function getUserStmtByExpr(st, expr) {
  return Caml_option.undefined_to_opt(st.stmts.find(function (stmt) {
                  var stmtExpr = stmt.expr;
                  if (stmtExpr !== undefined) {
                    return MM_context.exprEq(stmtExpr, expr);
                  }
                  throw {
                        RE_EXN_ID: MM_parser.MmException,
                        _1: {
                          msg: "Cannot getUserStmtByExpr without stmt.expr."
                        },
                        Error: new Error()
                      };
                }));
}

function insertStmt(st, expr, jstf, before, placeAtMaxIdxByDefault) {
  var wrkCtx = st.wrkCtx;
  if (wrkCtx !== undefined) {
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var hyp = MM_context.getHypByExpr(wrkCtx$1, expr);
    if (hyp !== undefined) {
      return [
              st,
              hyp.label
            ];
    }
    var maxIdx;
    if (before !== undefined) {
      var idx = st.stmts.findIndex(function (stmt) {
            return stmt.id === before;
          });
      maxIdx = idx !== -1 ? idx : st.stmts.length;
    } else {
      maxIdx = st.stmts.length;
    }
    var minIdx;
    if (jstf !== undefined) {
      var remainingLabels = Belt_HashSetString.fromArray(jstf.args);
      var minIdx$1 = st.stmts.reduce((function (minIdx, stmt, idx) {
              if (Belt_HashSetString.isEmpty(remainingLabels)) {
                return minIdx;
              } else {
                Belt_HashSetString.remove(remainingLabels, stmt.label);
                return idx + 1 | 0;
              }
            }), 0);
      minIdx = maxIdx < minIdx$1 ? maxIdx : minIdx$1;
    } else {
      minIdx = 0;
    }
    var insertNewStmt = function (st, existingStmt) {
      var newIdx;
      if (existingStmt !== undefined) {
        var newIdx$1 = getStmtIdx(st, existingStmt.id) + 1 | 0;
        newIdx = minIdx <= newIdx$1 && newIdx$1 <= maxIdx ? newIdx$1 : minIdx;
      } else {
        newIdx = placeAtMaxIdxByDefault ? maxIdx : minIdx;
      }
      var match = addNewStmtAtIdx(st, newIdx);
      var newStmtId = match[1];
      var st$1 = match[0];
      var st$2 = updateStmt(st$1, newStmtId, (function (stmt) {
              return {
                      id: stmt.id,
                      label: stmt.label,
                      labelEditMode: stmt.labelEditMode,
                      typ: /* P */1,
                      typEditMode: stmt.typEditMode,
                      cont: strToCont(MM_context.ctxIntsToStrExn(wrkCtx$1, expr), Caml_option.some(st$1.preCtxColors), Caml_option.some(st$1.wrkCtxColors), undefined),
                      contEditMode: false,
                      jstfText: Belt_Option.mapWithDefault(jstf, "", MM_statements_dto.jstfToStr),
                      jstfEditMode: stmt.jstfEditMode,
                      stmtErr: stmt.stmtErr,
                      expr: expr,
                      jstf: stmt.jstf,
                      proofTreeDto: stmt.proofTreeDto,
                      src: stmt.src,
                      proof: stmt.proof,
                      proofStatus: stmt.proofStatus,
                      unifErr: stmt.unifErr,
                      syntaxErr: stmt.syntaxErr
                    };
            }));
      return [
              st$2,
              editorGetStmtByIdExn(st$2, newStmtId).label
            ];
    };
    var existingJstfEqNewJstf = function (existingJstf) {
      if (jstf !== undefined) {
        return MM_statements_dto.jstfEq(existingJstf, jstf);
      } else {
        return false;
      }
    };
    var existingStmt = getUserStmtByExpr(st, expr);
    if (existingStmt === undefined) {
      return insertNewStmt(st, undefined);
    }
    if (existingStmt.typ === /* E */0) {
      return [
              st,
              existingStmt.label
            ];
    }
    var match = parseJstf(existingStmt.jstfText);
    if (match.TAG !== /* Ok */0) {
      return insertNewStmt(st, existingStmt);
    }
    var existingJstf = match._0;
    if (existingJstf !== undefined) {
      if (existingJstfEqNewJstf(existingJstf)) {
        return [
                st,
                existingStmt.label
              ];
      } else {
        return insertNewStmt(st, existingStmt);
      }
    } else {
      var st$1 = jstf !== undefined ? updateStmt(st, existingStmt.id, (function (stmt) {
                return {
                        id: stmt.id,
                        label: stmt.label,
                        labelEditMode: stmt.labelEditMode,
                        typ: stmt.typ,
                        typEditMode: stmt.typEditMode,
                        cont: stmt.cont,
                        contEditMode: stmt.contEditMode,
                        jstfText: MM_statements_dto.jstfToStr(jstf),
                        jstfEditMode: stmt.jstfEditMode,
                        stmtErr: stmt.stmtErr,
                        expr: stmt.expr,
                        jstf: stmt.jstf,
                        proofTreeDto: stmt.proofTreeDto,
                        src: stmt.src,
                        proof: stmt.proof,
                        proofStatus: stmt.proofStatus,
                        unifErr: stmt.unifErr,
                        syntaxErr: stmt.syntaxErr
                      };
              })) : st;
      return [
              st$1,
              existingStmt.label
            ];
    }
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot insertStmt without wrkCtx."
        },
        Error: new Error()
      };
}

function replaceDtoVarsWithCtxVarsInExprs(newStmts, newStmtsVarToCtxVar) {
  return {
          newVars: newStmts.newVars,
          newVarTypes: newStmts.newVarTypes,
          newDisj: newStmts.newDisj,
          newDisjStr: newStmts.newDisjStr,
          stmts: newStmts.stmts.map(function (stmt) {
                return {
                        label: stmt.label,
                        expr: stmt.expr.map(function (i) {
                              return Belt_MutableMapInt.getWithDefault(newStmtsVarToCtxVar, i, i);
                            }),
                        exprStr: stmt.exprStr,
                        jstf: stmt.jstf,
                        isProved: stmt.isProved
                      };
              })
        };
}

function addNewStatements(st, newStmts) {
  var match = createNewVars(st, newStmts.newVarTypes);
  var newCtxVarInts = match[1];
  var newStmtsVarToCtxVar = Belt_MutableMapInt.make(undefined);
  newStmts.newVars.forEach(function (newStmtsVarInt, i) {
        Belt_MutableMapInt.set(newStmtsVarToCtxVar, newStmtsVarInt, Caml_array.get(newCtxVarInts, i));
      });
  var newStmts$1 = replaceDtoVarsWithCtxVarsInExprs(newStmts, newStmtsVarToCtxVar);
  var newCtxDisj = MM_context.disjMake(undefined);
  MM_context.disjForEach(newStmts$1.newDisj, (function (n, m) {
          MM_context.disjAddPair(newCtxDisj, Belt_MutableMapInt.getWithDefault(newStmtsVarToCtxVar, n, n), Belt_MutableMapInt.getWithDefault(newStmtsVarToCtxVar, m, m));
        }));
  var st$1 = createNewDisj(match[0], newCtxDisj);
  var checkedStmt = getTopmostCheckedStmt(st$1);
  var newStmtsLabelToCtxLabel = Belt_MutableMapString.make(undefined);
  var replaceDtoLabelsWithCtxLabels = function (jstf) {
    return {
            args: jstf.args.map(function (arg) {
                  return Belt_MutableMapString.getWithDefault(newStmtsLabelToCtxLabel, arg, arg);
                }),
            label: jstf.label
          };
  };
  var mergeWillBeNeeded = newStmts$1.stmts.some(function (stmtDto) {
        return st$1.stmts.some(function (userStmt) {
                    return stmtsHaveSameExpr(userStmt, stmtDto);
                  });
      });
  var placeAtMaxIdxByDefault = Belt_Option.isSome(checkedStmt) && !mergeWillBeNeeded;
  var stMut = {
    contents: st$1
  };
  newStmts$1.stmts.forEach(function (stmtDto) {
        if (Belt_Option.isSome(checkedStmt) && stmtsHaveSameExpr(Belt_Option.getExn(checkedStmt), stmtDto)) {
          var checkedStmt$1 = Belt_Option.getExn(checkedStmt);
          stMut.contents = updateStmt(stMut.contents, checkedStmt$1.id, (function (stmtToUpdate) {
                  var jstf = stmtDto.jstf;
                  return {
                          id: stmtToUpdate.id,
                          label: stmtToUpdate.label,
                          labelEditMode: stmtToUpdate.labelEditMode,
                          typ: stmtToUpdate.typ,
                          typEditMode: stmtToUpdate.typEditMode,
                          cont: stmtToUpdate.cont,
                          contEditMode: stmtToUpdate.contEditMode,
                          jstfText: jstf !== undefined ? MM_statements_dto.jstfToStr(replaceDtoLabelsWithCtxLabels(jstf)) : stmtToUpdate.jstfText,
                          jstfEditMode: stmtToUpdate.jstfEditMode,
                          stmtErr: stmtToUpdate.stmtErr,
                          expr: stmtToUpdate.expr,
                          jstf: stmtToUpdate.jstf,
                          proofTreeDto: stmtToUpdate.proofTreeDto,
                          src: stmtToUpdate.src,
                          proof: stmtToUpdate.proof,
                          proofStatus: stmtToUpdate.proofStatus,
                          unifErr: stmtToUpdate.unifErr,
                          syntaxErr: stmtToUpdate.syntaxErr
                        };
                }));
          return Belt_MutableMapString.set(newStmtsLabelToCtxLabel, stmtDto.label, checkedStmt$1.label);
        }
        var match = insertStmt(stMut.contents, stmtDto.expr, Belt_Option.map(stmtDto.jstf, replaceDtoLabelsWithCtxLabels), Belt_Option.map(checkedStmt, (function (stmt) {
                    return stmt.id;
                  })), placeAtMaxIdxByDefault);
        stMut.contents = match[0];
        Belt_MutableMapString.set(newStmtsLabelToCtxLabel, stmtDto.label, match[1]);
      });
  return stMut.contents;
}

function verifyTypesForSubstitution(parenCnt, ctx, frms, wrkSubs) {
  var varToExprArr = Belt_MapInt.toArray(wrkSubs.subs);
  var typesToProve = varToExprArr.map(function (param) {
        return [MM_context.getTypeOfVarExn(ctx, param[0])].concat(param[1]);
      });
  var proofTree = MM_provers.proveFloatings(ctx, frms, typesToProve, parenCnt);
  varToExprArr.forEach(function (param, i) {
        if (!Belt_Option.isNone(wrkSubs.err)) {
          return ;
        }
        var typeExpr = Caml_array.get(typesToProve, i);
        if (Belt_Option.isNone(MM_proof_tree.pnGetProof(MM_proof_tree.ptGetNode(proofTree, typeExpr)))) {
          wrkSubs.err = {
            TAG: /* TypeMismatch */1,
            var: param[0],
            subsExpr: param[1],
            typeExpr: typeExpr
          };
          return ;
        }
        
      });
}

function convertSubsToWrkSubs(subs, tmpFrame, ctx) {
  var frameVarToCtxVar = function (frameVar) {
    var ctxSym = Belt_Array.get(tmpFrame.frameVarToSymb, frameVar);
    if (ctxSym !== undefined) {
      return MM_context.ctxSymToIntExn(ctx, ctxSym);
    }
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "Cannot convert frameVar to ctxVar."
          },
          Error: new Error()
        };
  };
  var res = Belt_HashMapInt.fromArray(Belt_Array.range(0, tmpFrame.numOfVars - 1 | 0).map(function (v) {
            return [
                    frameVarToCtxVar(v),
                    MM_substitution.applySubs([v], subs, (function (param) {
                            throw {
                                  RE_EXN_ID: MM_parser.MmException,
                                  _1: {
                                    msg: "Work variables are not supported in convertSubsToWrkSubs()."
                                  },
                                  Error: new Error()
                                };
                          }))
                  ];
          }));
  var maxVar = MM_context.getNumOfVars(ctx) - 1 | 0;
  for(var v = 0; v <= maxVar; ++v){
    if (!Belt_HashMapInt.has(res, v)) {
      Belt_HashMapInt.set(res, v, [v]);
    }
    
  }
  return {
          newDisj: MM_context.disjMake(undefined),
          subs: Belt_MapInt.fromArray(Belt_HashMapInt.toArray(res)),
          err: undefined
        };
}

function verifyDisjoints(wrkSubs, disj) {
  var varToSubVars = Belt_HashMapInt.make(Belt_MapInt.size(wrkSubs.subs));
  var getSubVars = function ($$var) {
    var arr = Belt_HashMapInt.get(varToSubVars, $$var);
    if (arr !== undefined) {
      return arr;
    }
    var expr = Belt_MapInt.get(wrkSubs.subs, $$var);
    Belt_HashMapInt.set(varToSubVars, $$var, expr !== undefined ? expr.filter(function (s) {
                return s >= 0;
              }) : []);
    return Belt_Option.getExn(Belt_HashMapInt.get(varToSubVars, $$var));
  };
  MM_context.disjForEach(disj, (function (n, m) {
          if (Belt_Option.isNone(wrkSubs.err)) {
            getSubVars(n).forEach(function (nv) {
                  if (Belt_Option.isNone(wrkSubs.err)) {
                    getSubVars(m).forEach(function (mv) {
                          if (Belt_Option.isNone(wrkSubs.err)) {
                            if (nv === mv) {
                              wrkSubs.err = {
                                TAG: /* CommonVar */0,
                                var1: n,
                                var2: m,
                                commonVar: nv
                              };
                            }
                            if (Belt_Option.isNone(wrkSubs.err) && !MM_context.disjContains(disj, nv, mv)) {
                              return MM_context.disjAddPair(wrkSubs.newDisj, nv, mv);
                            } else {
                              return ;
                            }
                          }
                          
                        });
                    return ;
                  }
                  
                });
            return ;
          }
          
        }));
}

function findPossibleSubs(st, frmExpr, expr) {
  var wrkCtx = st.wrkCtx;
  if (wrkCtx !== undefined) {
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var axLabel = Caml_array.get(MM_context.generateNewLabels(wrkCtx$1, "temp-ax-", 1, undefined, undefined, undefined), 0);
    var tmpFrame = MM_context.createFrame(wrkCtx$1, false, axLabel, MM_context.ctxIntsToSymsExn(wrkCtx$1, frmExpr), undefined, undefined, true, true, undefined);
    var frm = MM_substitution.prepareFrmSubsDataForFrame(tmpFrame);
    var disj = MM_context.getAllDisj(wrkCtx$1);
    var foundSubs = [];
    MM_substitution.iterateSubstitutions(tmpFrame.asrt, expr, Caml_array.get(frm.frmConstParts, frm.numOfHypsE), Caml_array.get(frm.constParts, frm.numOfHypsE), Caml_array.get(frm.varGroups, frm.numOfHypsE), frm.subs, st.parenCnt, (function (subs) {
            var wrkSubs = convertSubsToWrkSubs(subs, tmpFrame, wrkCtx$1);
            verifyDisjoints(wrkSubs, disj);
            if (Belt_Option.isNone(wrkSubs.err)) {
              verifyTypesForSubstitution(st.parenCnt, wrkCtx$1, st.frms, wrkSubs);
            }
            foundSubs.push(wrkSubs);
            return /* Continue */0;
          }));
    return foundSubs;
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot search for substitutions without wrkCtx."
        },
        Error: new Error()
      };
}

function applyWrkSubs(expr, wrkSubs) {
  var resultSize = {
    contents: 0
  };
  expr.forEach(function (s) {
        if (s < 0) {
          resultSize.contents = resultSize.contents + 1 | 0;
          return ;
        }
        var expr = Belt_MapInt.get(wrkSubs.subs, s);
        if (expr !== undefined) {
          resultSize.contents = resultSize.contents + expr.length | 0;
          return ;
        }
        throw {
              RE_EXN_ID: MM_parser.MmException,
              _1: {
                msg: "Cannot find a substitution for " + String(s) + " in applyWrkSubs."
              },
              Error: new Error()
            };
      });
  var res = new Array(resultSize.contents);
  var e = 0;
  var r = 0;
  while(r < resultSize.contents) {
    var s = Caml_array.get(expr, e);
    if (s < 0) {
      Caml_array.set(res, r, s);
      r = r + 1 | 0;
    } else {
      var subExpr = Belt_MapInt.getExn(wrkSubs.subs, s);
      var len = subExpr.length;
      Expln_utils_common.copySubArray(subExpr, 0, res, r, len);
      r = r + len | 0;
    }
    e = e + 1 | 0;
  };
  return res;
}

function applySubstitutionForEditor(st, wrkSubs) {
  var wrkCtx = st.wrkCtx;
  if (wrkCtx !== undefined) {
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var st$1 = createNewDisj(st, wrkSubs.newDisj);
    var newrecord = Caml_obj.obj_dup(st$1);
    newrecord.stmts = st$1.stmts.map(function (stmt) {
          var expr = MM_context.ctxSymsToIntsExn(wrkCtx$1, contToArrStr(stmt.cont));
          var newExpr = applyWrkSubs(expr, wrkSubs);
          return {
                  id: stmt.id,
                  label: stmt.label,
                  labelEditMode: stmt.labelEditMode,
                  typ: stmt.typ,
                  typEditMode: stmt.typEditMode,
                  cont: strToCont(MM_context.ctxIntsToStrExn(wrkCtx$1, newExpr), Caml_option.some(st$1.preCtxColors), Caml_option.some(st$1.wrkCtxColors), undefined),
                  contEditMode: stmt.contEditMode,
                  jstfText: stmt.jstfText,
                  jstfEditMode: stmt.jstfEditMode,
                  stmtErr: stmt.stmtErr,
                  expr: stmt.expr,
                  jstf: stmt.jstf,
                  proofTreeDto: stmt.proofTreeDto,
                  src: stmt.src,
                  proof: stmt.proof,
                  proofStatus: stmt.proofStatus,
                  unifErr: stmt.unifErr,
                  syntaxErr: stmt.syntaxErr
                };
        });
    return newrecord;
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot apply substitution without wrkCtx."
        },
        Error: new Error()
      };
}

function removeUnusedVars(st) {
  var wrkCtx = st.wrkCtx;
  if (wrkCtx !== undefined) {
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var usedSymbols = Belt_HashSetString.fromArray(Expln_utils_common.arrFlatMap(st.stmts, (function (stmt) {
                return contToArrStr(stmt.cont);
              })));
    MM_context.getLocalHyps(wrkCtx$1).forEach(function (hyp) {
          if (hyp.typ === /* F */0 && hyp.label.startsWith(".")) {
            return Belt_HashSetString.add(usedSymbols, MM_context.ctxIntToSymExn(wrkCtx$1, Caml_array.get(hyp.expr, 1)));
          }
          
        });
    var unusedVars = MM_context.getLocalVars(wrkCtx$1).filter(function ($$var) {
          return !Belt_HashSetString.has(usedSymbols, $$var);
        });
    var st$1;
    if (unusedVars.length === 0) {
      st$1 = st;
    } else {
      var unusedVarInts = Belt_HashSetInt.fromArray(MM_context.ctxSymsToIntsExn(wrkCtx$1, unusedVars));
      var usedLocalVarsStr = MM_context.getLocalHyps(wrkCtx$1).filter(function (hyp) {
                if (hyp.typ === /* F */0) {
                  return !Belt_HashSetInt.has(unusedVarInts, Caml_array.get(hyp.expr, 1));
                } else {
                  return false;
                }
              }).map(function (hyp) {
              return "" + hyp.label + " " + MM_context.ctxIntToSymExn(wrkCtx$1, Caml_array.get(hyp.expr, 0)) + " " + MM_context.ctxIntToSymExn(wrkCtx$1, Caml_array.get(hyp.expr, 1)) + "";
            }).join("\n");
      st$1 = completeVarsEditMode(st, usedLocalVarsStr);
    }
    var newDisj = MM_context.disjMake(undefined);
    MM_context.disjForEach(MM_context.getLocalDisj(wrkCtx$1), (function (n, m) {
            if (Belt_HashSetString.has(usedSymbols, MM_context.ctxIntToSymExn(wrkCtx$1, n)) && Belt_HashSetString.has(usedSymbols, MM_context.ctxIntToSymExn(wrkCtx$1, m))) {
              return MM_context.disjAddPair(newDisj, n, m);
            }
            
          }));
    var newDisjText = MM_context.disjToArr(newDisj).map(function (dgrp) {
            return MM_context.ctxIntsToSymsExn(wrkCtx$1, dgrp).join(",");
          }).join("\n");
    if (st$1.disjText !== newDisjText) {
      return completeDisjEditMode(st$1, newDisjText);
    } else {
      return st$1;
    }
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot remove unused variables without wrkCtx."
        },
        Error: new Error()
      };
}

function srcToJstf(wrkCtx, proofTree, exprSrc, exprToUserStmt) {
  if (typeof exprSrc === "number") {
    return ;
  }
  if (exprSrc.TAG !== /* Assertion */1) {
    return ;
  }
  var label = exprSrc.label;
  var args = exprSrc.args;
  var frame = MM_context.getFrame(wrkCtx, label);
  if (frame !== undefined) {
    var argLabels = [];
    var argLabelsValid = {
      contents: true
    };
    frame.hyps.forEach(function (hyp, i) {
          if (!(hyp.typ === /* E */1 && argLabelsValid.contents)) {
            return ;
          }
          var nodeIdx = Belt_Array.get(args, i);
          if (nodeIdx !== undefined) {
            var userStmt = Belt_HashMap.get(exprToUserStmt, Caml_array.get(proofTree.nodes, nodeIdx).expr);
            if (userStmt !== undefined) {
              argLabels.push(userStmt.label);
            } else {
              argLabelsValid.contents = false;
            }
            return ;
          }
          throw {
                RE_EXN_ID: MM_parser.MmException,
                _1: {
                  msg: "Too few arguments for '" + label + "' in srcToJstf."
                },
                Error: new Error()
              };
        });
    if (argLabelsValid.contents) {
      return {
              args: argLabels,
              label: label
            };
    } else {
      return ;
    }
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot find an assertion '" + label + "' in srcToJstf."
        },
        Error: new Error()
      };
}

function userStmtSetJstfTextAndProof(stmt, wrkCtx, proofTree, proofNode, exprToUserStmt) {
  var proofSrc = proofNode.proof;
  if (proofSrc === undefined) {
    return stmt;
  }
  var jstfFromProof = srcToJstf(wrkCtx, proofTree, proofSrc, exprToUserStmt);
  if (jstfFromProof === undefined) {
    return stmt;
  }
  var existingJstf = stmt.jstf;
  if (existingJstf !== undefined) {
    if (MM_statements_dto.jstfEq(jstfFromProof, existingJstf)) {
      return {
              id: stmt.id,
              label: stmt.label,
              labelEditMode: stmt.labelEditMode,
              typ: stmt.typ,
              typEditMode: stmt.typEditMode,
              cont: stmt.cont,
              contEditMode: stmt.contEditMode,
              jstfText: stmt.jstfText,
              jstfEditMode: stmt.jstfEditMode,
              stmtErr: stmt.stmtErr,
              expr: stmt.expr,
              jstf: stmt.jstf,
              proofTreeDto: proofTree,
              src: stmt.src,
              proof: proofNode,
              proofStatus: stmt.proofStatus,
              unifErr: stmt.unifErr,
              syntaxErr: stmt.syntaxErr
            };
    } else {
      return stmt;
    }
  } else {
    return {
            id: stmt.id,
            label: stmt.label,
            labelEditMode: stmt.labelEditMode,
            typ: stmt.typ,
            typEditMode: stmt.typEditMode,
            cont: stmt.cont,
            contEditMode: stmt.contEditMode,
            jstfText: MM_statements_dto.jstfToStr(jstfFromProof),
            jstfEditMode: stmt.jstfEditMode,
            stmtErr: stmt.stmtErr,
            expr: stmt.expr,
            jstf: stmt.jstf,
            proofTreeDto: proofTree,
            src: stmt.src,
            proof: proofNode,
            proofStatus: stmt.proofStatus,
            unifErr: stmt.unifErr,
            syntaxErr: stmt.syntaxErr
          };
  }
}

function getColorForSymbol(sym, preCtxColors, wrkCtxColors) {
  var color = Belt_HashMapString.get(preCtxColors, sym);
  if (color !== undefined) {
    return color;
  } else {
    return Belt_HashMapString.get(wrkCtxColors, sym);
  }
}

function addColorsToSyntaxTree(tree, preCtxColors, wrkCtxColors) {
  return {
          id: tree.id,
          parent: tree.parent,
          label: tree.label,
          children: tree.children.map(function (child) {
                if (child.TAG === /* Subtree */0) {
                  return {
                          TAG: /* Subtree */0,
                          _0: addColorsToSyntaxTree(child._0, preCtxColors, wrkCtxColors)
                        };
                } else {
                  return {
                          TAG: /* Symbol */1,
                          id: child.id,
                          parent: child.parent,
                          sym: child.sym,
                          color: getColorForSymbol(child.sym, preCtxColors, wrkCtxColors),
                          isVar: child.isVar
                        };
                }
              }),
          height: tree.height
        };
}

function checkParensMatch(expr, parenCnt) {
  var parenState = /* Balanced */0;
  MM_parenCounter.parenCntReset(parenCnt);
  var i = 0;
  while(i < expr.length && parenState !== /* Failed */2) {
    parenState = MM_parenCounter.parenCntPut(parenCnt, Caml_array.get(expr, i));
    i = i + 1 | 0;
  };
  return parenState === /* Balanced */0;
}

function stmtSetSyntaxTree(st, stmt, expr, wrkCtx, syntaxNodes, proofTreeDto) {
  var syms = stmt.cont;
  if (syms.TAG !== /* Text */0) {
    return stmt;
  }
  var nodeDto = Belt_HashMap.get(syntaxNodes, expr.slice(1));
  var syntaxTree = nodeDto !== undefined ? MM_syntax_tree.buildSyntaxTreeFromProofTreeDto(wrkCtx, proofTreeDto, nodeDto.expr) : undefined;
  if (syntaxTree !== undefined) {
    if (syntaxTree.TAG === /* Ok */0) {
      return {
              id: stmt.id,
              label: stmt.label,
              labelEditMode: stmt.labelEditMode,
              typ: stmt.typ,
              typEditMode: stmt.typEditMode,
              cont: {
                TAG: /* Tree */1,
                _0: {
                  exprTyp: Caml_array.get(syms._0, 0).sym,
                  root: addColorsToSyntaxTree(syntaxTree._0, st.preCtxColors, st.wrkCtxColors),
                  clickedNodeId: undefined,
                  expLvl: 0
                }
              },
              contEditMode: stmt.contEditMode,
              jstfText: stmt.jstfText,
              jstfEditMode: stmt.jstfEditMode,
              stmtErr: stmt.stmtErr,
              expr: stmt.expr,
              jstf: stmt.jstf,
              proofTreeDto: stmt.proofTreeDto,
              src: stmt.src,
              proof: stmt.proof,
              proofStatus: stmt.proofStatus,
              unifErr: stmt.unifErr,
              syntaxErr: stmt.syntaxErr
            };
    } else {
      return {
              id: stmt.id,
              label: stmt.label,
              labelEditMode: stmt.labelEditMode,
              typ: stmt.typ,
              typEditMode: stmt.typEditMode,
              cont: stmt.cont,
              contEditMode: stmt.contEditMode,
              jstfText: stmt.jstfText,
              jstfEditMode: stmt.jstfEditMode,
              stmtErr: stmt.stmtErr,
              expr: stmt.expr,
              jstf: stmt.jstf,
              proofTreeDto: stmt.proofTreeDto,
              src: stmt.src,
              proof: stmt.proof,
              proofStatus: stmt.proofStatus,
              unifErr: stmt.unifErr,
              syntaxErr: syntaxTree._0
            };
    }
  } else if (st.settings.checkSyntax) {
    return {
            id: stmt.id,
            label: stmt.label,
            labelEditMode: stmt.labelEditMode,
            typ: stmt.typ,
            typEditMode: stmt.typEditMode,
            cont: stmt.cont,
            contEditMode: stmt.contEditMode,
            jstfText: stmt.jstfText,
            jstfEditMode: stmt.jstfEditMode,
            stmtErr: stmt.stmtErr,
            expr: stmt.expr,
            jstf: stmt.jstf,
            proofTreeDto: stmt.proofTreeDto,
            src: stmt.src,
            proof: stmt.proof,
            proofStatus: stmt.proofStatus,
            unifErr: stmt.unifErr,
            syntaxErr: checkParensMatch(expr, st.parenCnt) ? "" : "parentheses mismatch"
          };
  } else {
    return stmt;
  }
}

function applyUnifyAllResults(st, proofTreeDto) {
  var wrkCtx = st.wrkCtx;
  if (wrkCtx !== undefined) {
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var exprToNode = Belt_HashMap.fromArray(proofTreeDto.nodes.map(function (node) {
              return [
                      node.expr,
                      node
                    ];
            }), MM_context.ExprHash);
    var exprToUserStmt = Belt_HashMap.fromArray(st.stmts.map(function (stmt) {
              var expr = stmt.expr;
              if (expr !== undefined) {
                return [
                        expr,
                        stmt
                      ];
              }
              throw {
                    RE_EXN_ID: MM_parser.MmException,
                    _1: {
                      msg: "Cannot applyUnifyAllResults without stmt.expr [1]."
                    },
                    Error: new Error()
                  };
            }), MM_context.ExprHash);
    var syntaxNodes = Belt_HashMap.fromArray(proofTreeDto.syntaxProofs, MM_context.ExprHash);
    return st.stmts.reduce((function (st, stmt) {
                  var stmt_id = stmt.id;
                  var stmt_label = stmt.label;
                  var stmt_labelEditMode = stmt.labelEditMode;
                  var stmt_typ = stmt.typ;
                  var stmt_typEditMode = stmt.typEditMode;
                  var stmt_cont = stmt.cont;
                  var stmt_contEditMode = stmt.contEditMode;
                  var stmt_jstfText = stmt.jstfText;
                  var stmt_jstfEditMode = stmt.jstfEditMode;
                  var stmt_stmtErr = stmt.stmtErr;
                  var stmt_expr = stmt.expr;
                  var stmt_jstf = stmt.jstf;
                  var stmt_proofTreeDto = stmt.proofTreeDto;
                  var stmt_src = stmt.src;
                  var stmt_unifErr = stmt.unifErr;
                  var stmt_syntaxErr = stmt.syntaxErr;
                  return updateStmt(st, stmt_id, (function (stmt) {
                                var expr = stmt.expr;
                                if (expr !== undefined) {
                                  var stmt$1 = stmtSetSyntaxTree(st, stmt, expr, wrkCtx$1, syntaxNodes, proofTreeDto);
                                  if (stmt$1.typ !== /* P */1) {
                                    return stmt$1;
                                  }
                                  var node = Belt_HashMap.get(exprToNode, expr);
                                  if (node !== undefined) {
                                    var stmt$2 = userStmtSetJstfTextAndProof(stmt$1, wrkCtx$1, proofTreeDto, node, exprToUserStmt);
                                    var proofNode = stmt$2.proof;
                                    if (proofNode !== undefined) {
                                      return {
                                              id: stmt$2.id,
                                              label: stmt$2.label,
                                              labelEditMode: stmt$2.labelEditMode,
                                              typ: stmt$2.typ,
                                              typEditMode: stmt$2.typEditMode,
                                              cont: stmt$2.cont,
                                              contEditMode: stmt$2.contEditMode,
                                              jstfText: stmt$2.jstfText,
                                              jstfEditMode: stmt$2.jstfEditMode,
                                              stmtErr: stmt$2.stmtErr,
                                              expr: stmt$2.expr,
                                              jstf: stmt$2.jstf,
                                              proofTreeDto: stmt$2.proofTreeDto,
                                              src: proofNode.proof,
                                              proof: stmt$2.proof,
                                              proofStatus: /* Ready */0,
                                              unifErr: stmt$2.unifErr,
                                              syntaxErr: stmt$2.syntaxErr
                                            };
                                    }
                                    var jstf = stmt$2.jstf;
                                    if (jstf === undefined) {
                                      return {
                                              id: stmt$2.id,
                                              label: stmt$2.label,
                                              labelEditMode: stmt$2.labelEditMode,
                                              typ: stmt$2.typ,
                                              typEditMode: stmt$2.typEditMode,
                                              cont: stmt$2.cont,
                                              contEditMode: stmt$2.contEditMode,
                                              jstfText: stmt$2.jstfText,
                                              jstfEditMode: stmt$2.jstfEditMode,
                                              stmtErr: stmt$2.stmtErr,
                                              expr: stmt$2.expr,
                                              jstf: stmt$2.jstf,
                                              proofTreeDto: stmt$2.proofTreeDto,
                                              src: stmt$2.src,
                                              proof: stmt$2.proof,
                                              proofStatus: /* NoJstf */2,
                                              unifErr: stmt$2.unifErr,
                                              syntaxErr: stmt$2.syntaxErr
                                            };
                                    }
                                    var src = node.parents.find(function (__x) {
                                          var jstfFromSrc = srcToJstf(wrkCtx$1, proofTreeDto, __x, exprToUserStmt);
                                          if (jstfFromSrc !== undefined) {
                                            return MM_statements_dto.jstfEq(jstf, jstfFromSrc);
                                          } else {
                                            return false;
                                          }
                                        });
                                    if (src !== undefined) {
                                      return {
                                              id: stmt$2.id,
                                              label: stmt$2.label,
                                              labelEditMode: stmt$2.labelEditMode,
                                              typ: stmt$2.typ,
                                              typEditMode: stmt$2.typEditMode,
                                              cont: stmt$2.cont,
                                              contEditMode: stmt$2.contEditMode,
                                              jstfText: stmt$2.jstfText,
                                              jstfEditMode: stmt$2.jstfEditMode,
                                              stmtErr: stmt$2.stmtErr,
                                              expr: stmt$2.expr,
                                              jstf: stmt$2.jstf,
                                              proofTreeDto: stmt$2.proofTreeDto,
                                              src: src,
                                              proof: stmt$2.proof,
                                              proofStatus: /* Waiting */1,
                                              unifErr: stmt$2.unifErr,
                                              syntaxErr: stmt$2.syntaxErr
                                            };
                                    }
                                    var errors = node.parents.map(function (src) {
                                              if (typeof src === "number" || src.TAG !== /* AssertionWithErr */2) {
                                                return ;
                                              } else {
                                                return [
                                                        src.label,
                                                        src.err
                                                      ];
                                              }
                                            }).filter(Belt_Option.isSome).map(Belt_Option.getExn);
                                    var unifErr;
                                    if (errors.length !== 1) {
                                      unifErr = undefined;
                                    } else {
                                      var match = errors[0];
                                      var asrtLabel = match[0];
                                      unifErr = MM_unification_debug.unifErrToStr(match[1], (function (param) {
                                              return MM_context.ctxIntsToStrExn(wrkCtx$1, param);
                                            }), (function (expr) {
                                              return MM_context.frmIntsToStrExn(wrkCtx$1, MM_context.getFrameExn(wrkCtx$1, asrtLabel), expr);
                                            }));
                                    }
                                    return {
                                            id: stmt$2.id,
                                            label: stmt$2.label,
                                            labelEditMode: stmt$2.labelEditMode,
                                            typ: stmt$2.typ,
                                            typEditMode: stmt$2.typEditMode,
                                            cont: stmt$2.cont,
                                            contEditMode: stmt$2.contEditMode,
                                            jstfText: stmt$2.jstfText,
                                            jstfEditMode: stmt$2.jstfEditMode,
                                            stmtErr: stmt$2.stmtErr,
                                            expr: stmt$2.expr,
                                            jstf: stmt$2.jstf,
                                            proofTreeDto: stmt$2.proofTreeDto,
                                            src: stmt$2.src,
                                            proof: stmt$2.proof,
                                            proofStatus: /* JstfIsIncorrect */3,
                                            unifErr: Belt_Option.orElse(stmt$2.unifErr, unifErr),
                                            syntaxErr: stmt$2.syntaxErr
                                          };
                                  }
                                  throw {
                                        RE_EXN_ID: MM_parser.MmException,
                                        _1: {
                                          msg: "exprToNode->Belt_HashMap.get(expr) is None"
                                        },
                                        Error: new Error()
                                      };
                                }
                                throw {
                                      RE_EXN_ID: MM_parser.MmException,
                                      _1: {
                                        msg: "Cannot applyUnifyAllResults without stmt.expr [2]."
                                      },
                                      Error: new Error()
                                    };
                              }));
                }), st);
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot applyUnifyAllResults without wrkCtx."
        },
        Error: new Error()
      };
}

function updateEditorStateWithPostupdateActions(st, update) {
  var st$1 = Curry._1(update, st);
  var st$2 = prepareEditorForUnification(st$1);
  if (Belt_Option.isSome(st$2.wrkCtx)) {
    return prepareEditorForUnification(removeUnusedVars(st$2));
  } else {
    return st$2;
  }
}

function splitIntoChunks(str, chunkMaxSize) {
  var len = str.length;
  if (len <= chunkMaxSize) {
    return [str];
  }
  var res = [];
  var numberOfChunks = Js_math.ceil_int(len / chunkMaxSize);
  for(var i = 1; i <= numberOfChunks; ++i){
    var begin = Math.imul(i - 1 | 0, chunkMaxSize);
    res.push(str.substr(begin, chunkMaxSize));
  }
  return res;
}

function proofToText(wrkCtx, newHyps, newDisj, stmt, proof) {
  if (proof.TAG === /* Uncompressed */0) {
    return "Error: only compressed proofs are supported.";
  }
  var blk = splitIntoChunks(proof.compressedProofBlock, 50).join(" ");
  var asrt = "" + stmt.label + " $p " + contToArrStr(stmt.cont).join(" ") + " $= ( " + proof.labels.join(" ") + " ) " + blk + " $.";
  var blockIsRequired = newHyps.length > 0 || !MM_context.disjIsEmpty(newDisj);
  var result = [];
  if (blockIsRequired) {
    result.push("${");
  }
  var varsArrStr = newHyps.filter(function (hyp) {
          return hyp.typ === /* F */0;
        }).map(function (hyp) {
        return MM_context.ctxIntToSymExn(wrkCtx, Caml_array.get(hyp.expr, 1));
      });
  if (varsArrStr.length > 0) {
    result.push("$v " + varsArrStr.join(" ") + " $.");
  }
  newHyps.forEach(function (hyp) {
        if (hyp.typ === /* F */0) {
          result.push(hyp.label + " $f " + MM_context.ctxIntsToStrExn(wrkCtx, hyp.expr) + " $.");
          return ;
        }
        
      });
  MM_context.disjForEachArr(newDisj, (function (vars) {
          result.push("$d " + MM_context.ctxIntsToStrExn(wrkCtx, vars) + " $.");
        }));
  newHyps.forEach(function (hyp) {
        if (hyp.typ === /* E */1) {
          result.push(hyp.label + " $e " + MM_context.ctxIntsToStrExn(wrkCtx, hyp.expr) + " $.");
          return ;
        }
        
      });
  result.push(asrt);
  if (blockIsRequired) {
    result.push("$}");
  }
  return result.join("\r\n");
}

function generateCompressedProof(st, stmtId) {
  var wrkCtx = st.wrkCtx;
  if (wrkCtx === undefined) {
    return ;
  }
  var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
  var stmt = editorGetStmtById(st, stmtId);
  if (stmt === undefined) {
    return ;
  }
  var proofTreeDto = stmt.proofTreeDto;
  if (proofTreeDto === undefined) {
    return ;
  }
  var proofNode = stmt.proof;
  if (proofNode === undefined) {
    return ;
  }
  var preCtx = st.preCtx;
  var expr = userStmtToRootStmt(stmt).expr;
  var proofTableWithTypes = MM_proof_tree_dto.createProofTable(proofTreeDto, proofNode, undefined, undefined, undefined);
  var proofTableWithoutTypes = MM_proof_tree_dto.createProofTable(proofTreeDto, proofNode, true, Caml_option.some(wrkCtx$1), undefined);
  var exprsUsedInProof = Belt_HashSet.fromArray(proofTableWithTypes.map(function (r) {
            return r.expr;
          }), MM_context.ExprHash);
  var rootStmts = st.stmts.map(userStmtToRootStmt);
  var proofCtx = MM_provers.createProofCtx(wrkCtx$1, rootStmts.filter(function (stmt) {
            if (stmt.isHyp) {
              return Belt_HashSet.has(exprsUsedInProof, stmt.expr);
            } else {
              return false;
            }
          }));
  var mandHyps = MM_context.getMandHyps(proofCtx, expr);
  var proof = MM_proof_table.createProof(mandHyps, proofTableWithTypes, proofTableWithTypes.length - 1 | 0);
  var newHyps = [];
  mandHyps.forEach(function (hyp) {
        if (Belt_Option.isNone(MM_context.getHypByExpr(preCtx, hyp.expr))) {
          newHyps.push(hyp);
          return ;
        }
        
      });
  var varsUsedInProof = Belt_HashSetInt.make(16);
  Belt_HashSet.forEach(exprsUsedInProof, (function (expr) {
          expr.forEach(function (s) {
                if (s >= 0) {
                  return Belt_HashSetInt.add(varsUsedInProof, s);
                }
                
              });
        }));
  var mandVars = Belt_HashSetInt.fromArray(mandHyps.map(function (hyp) {
            return Caml_array.get(hyp.expr, 1);
          }));
  MM_context.getLocalHyps(wrkCtx$1).forEach(function (hyp) {
        if (hyp.typ !== /* F */0) {
          return ;
        }
        var $$var = Caml_array.get(hyp.expr, 1);
        if (Belt_HashSetInt.has(varsUsedInProof, $$var) && !Belt_HashSetInt.has(mandVars, $$var)) {
          newHyps.push(hyp);
          return ;
        }
        
      });
  var newDisj = MM_context.disjMake(undefined);
  MM_proof_verifier.verifyProof(proofCtx, expr, proof, (function (n, m) {
          if (!MM_context.isDisj(wrkCtx$1, n, m)) {
            throw {
                  RE_EXN_ID: MM_parser.MmException,
                  _1: {
                    msg: "!(wrkCtx->isDisj(n,m))"
                  },
                  Error: new Error()
                };
          }
          if (!MM_context.isDisj(preCtx, n, m)) {
            MM_context.disjAddPair(newDisj, n, m);
          }
          return true;
        }));
  return [
          proofToText(wrkCtx$1, newHyps, newDisj, stmt, proof),
          MM_proof_table.proofTableToStr(wrkCtx$1, proofTableWithTypes, stmt.label),
          MM_proof_table.proofTableToStr(wrkCtx$1, proofTableWithoutTypes, stmt.label)
        ];
}

function replaceRef(st, replaceWhat, replaceWith) {
  return st.stmts.reduce((function (res, stmt) {
                if (res.TAG !== /* Ok */0) {
                  return res;
                }
                var st = res._0;
                var match = parseJstf(stmt.jstfText);
                if (match.TAG !== /* Ok */0) {
                  return {
                          TAG: /* Error */1,
                          _0: "Cannot parse justification '" + stmt.jstfText + "' " + ("for the statement '" + stmt.label + "'")
                        };
                }
                var jstf = match._0;
                if (jstf === undefined) {
                  return {
                          TAG: /* Ok */0,
                          _0: st
                        };
                }
                if (!jstf.args.includes(replaceWhat)) {
                  return {
                          TAG: /* Ok */0,
                          _0: st
                        };
                }
                var newJstf_args = jstf.args.map(function (ref) {
                      if (ref === replaceWhat) {
                        return replaceWith;
                      } else {
                        return ref;
                      }
                    });
                var newJstf_label = jstf.label;
                var newJstf = {
                  args: newJstf_args,
                  label: newJstf_label
                };
                return {
                        TAG: /* Ok */0,
                        _0: updateStmt(st, stmt.id, (function (stmt) {
                                return {
                                        id: stmt.id,
                                        label: stmt.label,
                                        labelEditMode: stmt.labelEditMode,
                                        typ: stmt.typ,
                                        typEditMode: stmt.typEditMode,
                                        cont: stmt.cont,
                                        contEditMode: stmt.contEditMode,
                                        jstfText: MM_statements_dto.jstfToStr(newJstf),
                                        jstfEditMode: stmt.jstfEditMode,
                                        stmtErr: stmt.stmtErr,
                                        expr: stmt.expr,
                                        jstf: stmt.jstf,
                                        proofTreeDto: stmt.proofTreeDto,
                                        src: stmt.src,
                                        proof: stmt.proof,
                                        proofStatus: stmt.proofStatus,
                                        unifErr: stmt.unifErr,
                                        syntaxErr: stmt.syntaxErr
                                      };
                              }))
                      };
              }), {
              TAG: /* Ok */0,
              _0: st
            });
}

function mergeStmts(st, id1, id2) {
  var stmt1 = editorGetStmtById(st, id1);
  if (stmt1 === undefined) {
    return {
            TAG: /* Error */1,
            _0: "Cannot find a statement with id = '" + id1 + "'"
          };
  }
  var stmt2 = editorGetStmtById(st, id2);
  if (stmt2 === undefined) {
    return {
            TAG: /* Error */1,
            _0: "Cannot find a statement with id = '" + id2 + "'"
          };
  }
  if (contToArrStr(stmt1.cont).join(" ") !== contToArrStr(stmt2.cont).join(" ")) {
    return {
            TAG: /* Error */1,
            _0: "Statements to merge must have identical expressions."
          };
  }
  var msg = replaceRef(st, stmt2.label, stmt1.label);
  if (msg.TAG !== /* Ok */0) {
    return {
            TAG: /* Error */1,
            _0: msg._0
          };
  }
  var st$1 = deleteStmt(msg._0, id2);
  return {
          TAG: /* Ok */0,
          _0: st$1
        };
}

var symbolsNotAllowedInLabelRegex = /[\s:]+/g;

function renameStmt(st, stmtId, newLabel) {
  var newLabel$1 = newLabel.replace(symbolsNotAllowedInLabelRegex, "");
  if (newLabel$1 === "") {
    return {
            TAG: /* Error */1,
            _0: "label must not be empty."
          };
  }
  var match = st.stmts.find(function (stmt) {
        if (stmt.id !== stmtId) {
          return stmt.label === newLabel$1;
        } else {
          return false;
        }
      });
  if (match !== undefined) {
    return {
            TAG: /* Error */1,
            _0: "label '" + newLabel$1 + "' is used by another statement."
          };
  }
  var stmt = editorGetStmtById(st, stmtId);
  if (stmt === undefined) {
    return {
            TAG: /* Ok */0,
            _0: st
          };
  }
  if (stmt.label === newLabel$1) {
    return {
            TAG: /* Ok */0,
            _0: st
          };
  }
  var msg = replaceRef(st, stmt.label, newLabel$1);
  if (msg.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: updateStmt(msg._0, stmtId, (function (stmt) {
                    return {
                            id: stmt.id,
                            label: newLabel$1,
                            labelEditMode: stmt.labelEditMode,
                            typ: stmt.typ,
                            typEditMode: stmt.typEditMode,
                            cont: stmt.cont,
                            contEditMode: stmt.contEditMode,
                            jstfText: stmt.jstfText,
                            jstfEditMode: stmt.jstfEditMode,
                            stmtErr: stmt.stmtErr,
                            expr: stmt.expr,
                            jstf: stmt.jstf,
                            proofTreeDto: stmt.proofTreeDto,
                            src: stmt.src,
                            proof: stmt.proof,
                            proofStatus: stmt.proofStatus,
                            unifErr: stmt.unifErr,
                            syntaxErr: stmt.syntaxErr
                          };
                  }))
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: msg._0
          };
  }
}

function findStmtsToMerge(st) {
  if (st.checkedStmtIds.length !== 1) {
    return {
            TAG: /* Error */1,
            _0: "One statement should be selected [2]."
          };
  }
  var stmt1 = editorGetStmtById(st, Caml_array.get(st.checkedStmtIds, 0));
  if (stmt1 === undefined) {
    return {
            TAG: /* Error */1,
            _0: "One statement should be selected [1]."
          };
  }
  var contStr = contToArrStr(stmt1.cont).join(" ");
  var stmt2 = st.stmts.find(function (stmt) {
        if (stmt.id !== stmt1.id) {
          return contToArrStr(stmt.cont).join(" ") === contStr;
        } else {
          return false;
        }
      });
  if (stmt2 !== undefined) {
    return {
            TAG: /* Ok */0,
            _0: [
              stmt1,
              stmt2
            ]
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: "Cannot find another statement to merge with."
          };
  }
}

function getIdsOfAllChildSymbols(tree) {
  var res = [];
  Expln_utils_data.traverseTree(undefined, {
        TAG: /* Subtree */0,
        _0: tree
      }, (function (param, node) {
          if (node.TAG === /* Subtree */0) {
            return node._0.children;
          }
          
        }), undefined, (function (param, node) {
          if (node.TAG !== /* Subtree */0) {
            res.push(node.id);
          }
          
        }), undefined, undefined);
  return Belt_SetInt.fromArray(res);
}

function getIdsOfSelectedNodesFromTreeData(treeData) {
  var nodeId = treeData.clickedNodeId;
  if (nodeId === undefined) {
    return [
            -1,
            undefined
          ];
  }
  var match = MM_syntax_tree.getNodeById(treeData.root, nodeId);
  if (match === undefined) {
    return [
            -1,
            undefined
          ];
  }
  if (match.TAG === /* Subtree */0) {
    return [
            -1,
            undefined
          ];
  }
  var parent = match.parent;
  if (treeData.expLvl === 0) {
    if (match.isVar) {
      return [
              nodeId,
              Belt_SetInt.fromArray([nodeId])
            ];
    } else {
      return [
              nodeId,
              getIdsOfAllChildSymbols(parent)
            ];
    }
  }
  var curParent = parent;
  var curLvl = treeData.expLvl;
  while(curLvl > 0 && Belt_Option.isSome(curParent)) {
    curLvl = curLvl - 1 | 0;
    curParent = Belt_Option.getExn(curParent).parent;
  };
  var parent$1 = curParent;
  if (parent$1 !== undefined) {
    return [
            nodeId,
            getIdsOfAllChildSymbols(parent$1)
          ];
  } else {
    return [
            nodeId,
            getIdsOfAllChildSymbols(treeData.root)
          ];
  }
}

function getNumberOfSelectedSymbols(treeData) {
  var match = getIdsOfSelectedNodesFromTreeData(treeData);
  return Belt_SetInt.size(match[1]);
}

function getIdsOfSelectedNodes(stmtCont) {
  if (stmtCont.TAG === /* Text */0) {
    return [
            -1,
            undefined
          ];
  } else {
    return getIdsOfSelectedNodesFromTreeData(stmtCont._0);
  }
}

function getNodeIdBySymIdx(symIdx, tree) {
  return Expln_utils_data.traverseTree({
                contents: 0
              }, {
                TAG: /* Subtree */0,
                _0: tree
              }, (function (param, node) {
                  if (node.TAG === /* Subtree */0) {
                    return node._0.children;
                  }
                  
                }), undefined, (function (cnt, node) {
                  if (node.TAG === /* Subtree */0) {
                    return ;
                  }
                  cnt.contents = cnt.contents + 1 | 0;
                  if (cnt.contents === symIdx) {
                    return node.id;
                  }
                  
                }), undefined, undefined)[1];
}

function getSelectedSymbols(stmtCont) {
  if (stmtCont.TAG === /* Text */0) {
    return ;
  }
  var match = getIdsOfSelectedNodes(stmtCont);
  var selectedIds = match[1];
  if (Belt_SetInt.isEmpty(selectedIds)) {
    return ;
  }
  var syms = [];
  Expln_utils_data.traverseTree(undefined, {
        TAG: /* Subtree */0,
        _0: stmtCont._0.root
      }, (function (param, node) {
          if (node.TAG === /* Subtree */0) {
            return node._0.children;
          }
          
        }), undefined, (function (param, node) {
          if (node.TAG !== /* Subtree */0) {
            if (Belt_SetInt.has(selectedIds, node.id)) {
              syms.push(node.sym);
            }
            
          }
          
        }), undefined, undefined);
  return syms;
}

function hasSelectedText(stmtCont) {
  if (stmtCont.TAG === /* Text */0) {
    return false;
  } else {
    return stmtCont._0.clickedNodeId !== undefined;
  }
}

function getSelectedText(stmtCont) {
  return Belt_Option.map(getSelectedSymbols(stmtCont), (function (__x) {
                return __x.join(" ");
              }));
}

function incExpLvl(treeData) {
  return {
          exprTyp: treeData.exprTyp,
          root: treeData.root,
          clickedNodeId: treeData.clickedNodeId,
          expLvl: Math.min(treeData.expLvl + 1 | 0, treeData.root.height)
        };
}

function decExpLvl(treeData) {
  return {
          exprTyp: treeData.exprTyp,
          root: treeData.root,
          clickedNodeId: treeData.clickedNodeId,
          expLvl: Math.max(treeData.expLvl - 1 | 0, 0)
        };
}

function getAllExprsToSyntaxCheck(st, rootStmts) {
  var res = [];
  st.stmts.forEach(function (stmt, i) {
        var match = stmt.cont;
        if (match.TAG !== /* Text */0) {
          return ;
        }
        res.push(Caml_array.get(rootStmts, i).expr.slice(1));
      });
  return res;
}

exports.contIsEmpty = contIsEmpty;
exports.contToArrStr = contToArrStr;
exports.contToStr = contToStr;
exports.strToCont = strToCont;
exports.userStmtTypeFromStr = userStmtTypeFromStr;
exports.userStmtTypeToStr = userStmtTypeToStr;
exports.readInstrToStr = readInstrToStr;
exports.readInstrFromStr = readInstrFromStr;
exports.mmFileSourceTypeToStr = mmFileSourceTypeToStr;
exports.mmFileSourceTypeFromStr = mmFileSourceTypeFromStr;
exports.mmFileSourceTypeFromStrOpt = mmFileSourceTypeFromStrOpt;
exports.createEmptyUserStmt = createEmptyUserStmt;
exports.userStmtToRootStmt = userStmtToRootStmt;
exports.updateStmt = updateStmt;
exports.isStmtChecked = isStmtChecked;
exports.toggleStmtChecked = toggleStmtChecked;
exports.checkAllStmts = checkAllStmts;
exports.uncheckAllStmts = uncheckAllStmts;
exports.deleteCheckedStmts = deleteCheckedStmts;
exports.deleteStmt = deleteStmt;
exports.canMoveCheckedStmts = canMoveCheckedStmts;
exports.moveCheckedStmts = moveCheckedStmts;
exports.getRootStmtsForUnification = getRootStmtsForUnification;
exports.addNewStmt = addNewStmt;
exports.isSingleStmtChecked = isSingleStmtChecked;
exports.duplicateCheckedStmt = duplicateCheckedStmt;
exports.canGoEditModeForStmt = canGoEditModeForStmt;
exports.setDescrEditMode = setDescrEditMode;
exports.completeDescrEditMode = completeDescrEditMode;
exports.setVarsEditMode = setVarsEditMode;
exports.completeVarsEditMode = completeVarsEditMode;
exports.setDisjEditMode = setDisjEditMode;
exports.completeDisjEditMode = completeDisjEditMode;
exports.setLabelEditMode = setLabelEditMode;
exports.completeLabelEditMode = completeLabelEditMode;
exports.setContEditMode = setContEditMode;
exports.completeContEditMode = completeContEditMode;
exports.setStmtCont = setStmtCont;
exports.setTypEditMode = setTypEditMode;
exports.completeTypEditMode = completeTypEditMode;
exports.setJstfEditMode = setJstfEditMode;
exports.completeJstfEditMode = completeJstfEditMode;
exports.incUnifyAllIsRequiredCnt = incUnifyAllIsRequiredCnt;
exports.setSettings = setSettings;
exports.setPreCtx = setPreCtx;
exports.editorStateHasErrors = editorStateHasErrors;
exports.prepareEditorForUnification = prepareEditorForUnification;
exports.addNewStatements = addNewStatements;
exports.findPossibleSubs = findPossibleSubs;
exports.applySubstitutionForEditor = applySubstitutionForEditor;
exports.removeUnusedVars = removeUnusedVars;
exports.applyUnifyAllResults = applyUnifyAllResults;
exports.updateEditorStateWithPostupdateActions = updateEditorStateWithPostupdateActions;
exports.generateCompressedProof = generateCompressedProof;
exports.updateColorsInAllStmts = updateColorsInAllStmts;
exports.getTheOnlyCheckedStmt = getTheOnlyCheckedStmt;
exports.editorGetStmtById = editorGetStmtById;
exports.getAllExprsToSyntaxCheck = getAllExprsToSyntaxCheck;
exports.mergeStmts = mergeStmts;
exports.renameStmt = renameStmt;
exports.findStmtsToMerge = findStmtsToMerge;
exports.parseJstf = parseJstf;
exports.getIdsOfSelectedNodes = getIdsOfSelectedNodes;
exports.hasSelectedText = hasSelectedText;
exports.getSelectedText = getSelectedText;
exports.getNodeIdBySymIdx = getNodeIdBySymIdx;
exports.incExpLvl = incExpLvl;
exports.decExpLvl = decExpLvl;
exports.getNumberOfSelectedSymbols = getNumberOfSelectedSymbols;
exports.getSelectedSymbols = getSelectedSymbols;
exports.addColorsToSyntaxTree = addColorsToSyntaxTree;
exports.getColorForSymbol = getColorForSymbol;
/* Common Not a pure module */
